import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Grid,
    Checkbox,
    Card,
    Radio,
    IconButton,
    Input,
} from '@material-ui/core';
import Header from 'Components/lto/common/Header';
import {T} from 'Actions/translate';
import ProductCard from 'Components/order/ProductCard';
import ChangeShipmentCard from 'Components/order/ChangeShipmentCard';
import {
    queryCart,
    queryChangeShip,
    deleteCart,
    calculatePrice,
    sumbitQuantity,
    queryEoneInventory,
    getQuote,
    getCustomerQuote,
    addCart,
    getCartCount,
    operationLog,
    calculateSquotePrice,
    updateSwitchChoosePrice,
    batchAddCart,
    updateFromShoppingCart,
    checkedAssayId,
} from 'Actions/order';
import BasicButton from 'Components/common/BasicButton';
import Anchor from 'Components/common/Anchor';
import {setCartDetails, setCartOrderNumber} from 'Actions/localData';
import LabelInput from 'Components/common/LabelInput';
import util from 'Utils/commonUtil';
import LoadingIcon from 'Components/icons/LoadingIcon';
import Dialog from 'Components/common/Dialog';
import {openNotification} from 'Actions/notification';
import copy from 'copy-to-clipboard';
import {loadLanguage} from 'Utils/jwtUtil';
import SQuoteItem from 'Components/commonOrder/SQuoteItem';
import {
    NO_SUPPLY_CENTER_ID,
    PRODUCT_TYPE,
    APPLY_QUOTE_TYPE,
    APPLY_QUOTE_ERROR_CODE,
    PURCHASE_ORDER_MODE,
    PRODUCT_SOURCE,
} from 'Utils/constant';
import Counter from 'Components/counter/Counter';

// Icons
import {
    ShoppingCartOutlined,
    InfoOutlined,
    AddCircle,
    PlaceOutlined,
} from '@material-ui/icons';

class ShoppingCart extends Component {
    state = {
        checkAll: true,
        deleteStatus: true,
        defaultCheck: null,
        checkNum: 0,
        discountCode: '',
        inputdiscountCodeList: [],
        pageLoading: false,
        isOnlinePrice: false,
        initial: true,
        promoWarningFlg: false,
        disabledSelected: [],
        cartProductList: [],
        isQuoteInfor: false,
        pageLoad: true,
        displayTMProduct: false,
        isDemoSite: false,
        reselectAllProductCheck: null,
        sQuote: '',
        discountFocus: true,
        sQuoteClearFlg: false,
        sQuoteConfirmFlg: false,
        sQuoteNum: 0,
        cartUpdate: true,
        promoErrorMsg: '',
        isOpenchangeShipDialog: false,
        changeShipmentList: [],
        changeSkuList: [],
        changeShipmentListLoading: false,
        originalCartProductList: [],
        existOnlinePriceDialog: false,
        dialogApplyCodeParams: {},
        dialogInputdiscountCodeList: [],
        applyQuoteOperation: false,
        updateChoosePrice: '',
        quickAddSkuValue: '',
        quickAddSkuQuantity: 1,
        changeDeliveryChannelToE1Dialog: false,
    };

    componentWillMount() {
        const {localData} = this.props;

        this.props.calculateSquotePrice({}, true);
    }

    getBatchAddEmail = () => {
        let currentBatchAddEmail = '';
        if (
            this.props.location.state &&
            this.props.location.state.batchAddEmail
        ) {
            currentBatchAddEmail = this.props.location.state.batchAddEmail;
        }
        return currentBatchAddEmail;
    };

    getBatchAddShipTo = () => {
        let currentBatchAddShipTo = '';
        if (
            this.props.location.state &&
            this.props.location.state.batchAddShipTo
        ) {
            currentBatchAddShipTo = this.props.location.state.batchAddShipTo;
        }
        return currentBatchAddShipTo;
    };

    componentDidMount() {
        this.initShoppingCart();
    }

    initShoppingCart = () => {
        const {localData} = this.props;

        if (localData) {
            this.props.setCartDetails({
                skuPrices: [],
            });
            this.props.calculatePrice({}, true);
            this.queryCart();
        }
        localStorage.setItem('changSkuTypeList', []);

        if (
            this.getBatchAddShipTo() &&
            document.getElementById('header-background')
        ) {
            if (util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE) {
                document.getElementById('header-background').style.height =
                    7.3 + 'rem';
            } else {
                document.getElementById('header-background').style.height =
                    8.3 + 'rem';
            }
        }
    };

    getCartAllSkuList = () => {
        let currentCartProductList = this.state.cartProductList;
        let skuList = [];
        for (let i = 0; i < currentCartProductList.length; i++) {
            skuList.push(currentCartProductList[i].product.sku);
        }
        return skuList;
    };

    isOemCart = (cartItem) => {
        return (
            cartItem &&
            cartItem.product &&
            cartItem.product.productSource === PRODUCT_SOURCE.OEM
        );
    };

    isMQuoteSupplyCenterCart = (cartItem) => {
        return (
            cartItem &&
            cartItem.product &&
            !this.isOemCart(cartItem) &&
            cartItem.product.type === PRODUCT_TYPE.SUPPLY_CENTER_ORDER
        );
    };

    // Hide API Get Loading
    hideloading = () => {
        this.setState({
            pageLoad: false,
        });
    };

    handleMQuoteSuccessCartPrice = (cartPrice) => {
        let productDetails = [];
        let tempFreeGoodCartList = [];
        //TODO
        if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
            let isOnlyFreeGoodCartList = cartPrice.data.skuPrices.filter(
                (item, freeGoodIndex) => {
                    return item.freeGoodItem;
                },
            );
            let isNotFreeGoodCartList = cartPrice.data.skuPrices.filter(
                (item) => {
                    return !item.freeGoodItem;
                },
            );
            productDetails =
                isNotFreeGoodCartList.length > 0 &&
                isNotFreeGoodCartList.map((item) => {
                    return this.getSkuPriceObj(item);
                });

            tempFreeGoodCartList =
                isOnlyFreeGoodCartList.length > 0 &&
                isOnlyFreeGoodCartList.map((item) => {
                    return this.getSkuPriceObj(item);
                });
        }
        return [...productDetails, ...tempFreeGoodCartList];
    };

    mergeUpdateQuantity = (cartPrice, currentCartProductList) => {
        let currentCartPrice = JSON.parse(JSON.stringify(cartPrice));
        let mergeIsNotFreeGoodCartPrice = [];
        let mergeIsOnlyFreeGoodCartPrice = [];

        if (
            currentCartPrice.data &&
            currentCartPrice.data.skuPrices.length > 0
        ) {
            let isOnlyFreeGoodCartPrice =
                currentCartPrice.data.skuPrices.filter(
                    (item, freeGoodIndex) => {
                        return item.freeGoodItem;
                    },
                );
            let isNotFreeGoodCartPrice = currentCartPrice.data.skuPrices.filter(
                (item) => {
                    return !item.freeGoodItem;
                },
            );

            let isOnlyFreeGoodCartProductList = currentCartProductList.filter(
                (item, freeGoodIndex) => {
                    return item.product.freeGoodItem;
                },
            );
            let isNotFreeGoodCartProductList = currentCartProductList.filter(
                (item) => {
                    return !item.product.freeGoodItem;
                },
            );

            isNotFreeGoodCartPrice.length > 0 &&
                isNotFreeGoodCartPrice.forEach((notFreeGoodCartPrice) => {
                    isNotFreeGoodCartProductList.length > 0 &&
                        isNotFreeGoodCartProductList.forEach(
                            (notFreeGoodCartProduct) => {
                                if (
                                    notFreeGoodCartPrice.cartId ===
                                    notFreeGoodCartProduct.id
                                ) {
                                    notFreeGoodCartPrice.quantity =
                                        notFreeGoodCartProduct.quantity;
                                }

                                let isExist = mergeIsNotFreeGoodCartPrice.some(
                                    (skuItem) =>
                                        skuItem.cartId ===
                                            notFreeGoodCartPrice.cartId &&
                                        !skuItem.freeGoodItem ===
                                            !notFreeGoodCartPrice.freeGoodItem,
                                );
                                if (!isExist) {
                                    mergeIsNotFreeGoodCartPrice.push(
                                        this.getSkuPriceObj(
                                            notFreeGoodCartPrice,
                                        ),
                                    );
                                }
                            },
                        );
                });
            isOnlyFreeGoodCartPrice.length > 0 &&
                isOnlyFreeGoodCartPrice.forEach((isOnlyFreeGoodCartPrice) => {
                    isOnlyFreeGoodCartProductList.length > 0 &&
                        isOnlyFreeGoodCartProductList.forEach(
                            (isOnlyFreeGoodCartProduct) => {
                                isOnlyFreeGoodCartPrice.quantity =
                                    isOnlyFreeGoodCartProduct.quantity;
                                let isExist = mergeIsOnlyFreeGoodCartPrice.some(
                                    (skuItem) =>
                                        skuItem.cartId ===
                                            isOnlyFreeGoodCartPrice.cartId &&
                                        !skuItem.freeGoodItem ===
                                            !isOnlyFreeGoodCartPrice.freeGoodItem,
                                );
                                if (!isExist) {
                                    mergeIsOnlyFreeGoodCartPrice.push(
                                        this.getSkuPriceObj(
                                            isOnlyFreeGoodCartPrice,
                                        ),
                                    );
                                }
                            },
                        );
                });

            console.log(
                mergeIsNotFreeGoodCartPrice,
                mergeIsOnlyFreeGoodCartPrice,
            );
            return [
                ...mergeIsNotFreeGoodCartPrice,
                ...mergeIsOnlyFreeGoodCartPrice,
            ];
        }
    };

    getAllMQuoteSkuPrices = (cartPrice, cartProductList) => {
        const priceSkuPrices =
            (cartPrice.data && cartPrice.data.skuPrices) || [];
        const priceByCartId = priceSkuPrices
            .filter((item) => !item.freeGoodItem)
            .reduce((prices, item) => {
                prices[item.cartId] = item;
                return prices;
            }, {});
        const primarySkuPrices = (cartProductList || [])
            .filter(
                (item) =>
                    item.product &&
                    item.product.available &&
                    !item.product.freeGoodItem,
            )
            .map((item) => {
                const price = priceByCartId[item.id];
                const skuPrice = {
                    cartId: item.id,
                    finalPrice: item.product.efPrice || item.product.finalPrice,
                    listPrice: item.product.listPrice,
                    noPromoPrice: item.product.finalPrice,
                    sku: item.product.sku,
                    productName: item.product.productName,
                    quantity: item.quantity,
                    freeGoodItem: item.product.freeGoodItem,
                };
                return price
                    ? {...skuPrice, ...this.getSkuPriceObj(price)}
                    : skuPrice;
            });
        const selectedCartIds = primarySkuPrices.map((item) => item.cartId);
        const freeGoodSkuPrices = priceSkuPrices
            .filter(
                (item) =>
                    item.freeGoodItem && selectedCartIds.includes(item.cartId),
            )
            .map((item) => this.getSkuPriceObj(item));

        return [...primarySkuPrices, ...freeGoodSkuPrices];
    };

    // Check All the product
    handleCheck = (event) => {
        const {cartList, localData, cartPrice} = this.props;
        const {cartProductList} = this.state;
        let selectedProductArray = [];
        let selectedDisabledProduct = [];
        let currentCartProductList = JSON.parse(
            JSON.stringify(cartProductList),
        );
        // console.log("handleCheck=======================cartProductList", JSON.parse(JSON.stringify(cartProductList)));
        // console.log("handleCheck=======================cartPrice", JSON.parse(JSON.stringify(cartPrice)));

        if (event.target.checked) {
            if (this.isApplyMQuote()) {
                selectedProductArray = this.getAllMQuoteSkuPrices(
                    cartPrice,
                    currentCartProductList,
                );
            } else {
                if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
                    //应用quote有值，反之
                    cartList &&
                        cartList.forEach((cartItem) => {
                            cartPrice.data.skuPrices.forEach((skuPriceItem) => {
                                if (cartItem.product.sku === skuPriceItem.sku) {
                                    if (cartItem.product.available) {
                                        cartItem.product.finalPrice =
                                            skuPriceItem.finalPrice;
                                    }
                                }
                            });
                        });
                }

                cartList &&
                    cartList.forEach((item) => {
                        if (item.product.available) {
                            console.log(
                                'aaaa111111111111111111111111111111111111111111111',
                            );
                            selectedProductArray.push({
                                cartId: item.id,
                                finalPrice:
                                    item.product.efPrice ||
                                    item.product.finalPrice,
                                quantity: item.quantity,
                                noPromoPrice: item.product.finalPrice,
                                sku: item.product.sku,
                                productName: item.product.productName,
                                listPrice: item.product.listPrice,
                            });
                        } else {
                            selectedDisabledProduct.push({
                                cartId: item.id,
                                quantity: item.quantity,
                            });
                        }
                    });
            }
        } else {
            selectedProductArray = [];
        }

        let currentCheckNum = 0;
        if (this.isApplyMQuote()) {
            this.props.setCartDetails({
                skuPrices: selectedProductArray,
            });

            selectedProductArray.length &&
                selectedProductArray.forEach((item) => {
                    currentCheckNum += item.quantity;
                });
        } else {
            this.changeSelectProductDetails(selectedProductArray, true);
            currentCheckNum = event.target.checked ? this.getTotal() : 0;
        }

        this.setState({
            checkAll: event.target.checked,
            defaultCheck: event.target.checked,
            reselectAllProductCheck: event.target.checked,
            checkNum: currentCheckNum,
            disabledSelected: selectedDisabledProduct,
            cartUpdate: true,
        });
    };

    // Recalculate checked product number
    getTotal = () => {
        const {cartList} = this.props;
        const {cartProductList} = this.state;
        let total = 0;

        if (this.isApplyMQuote()) {
            cartProductList &&
                cartProductList.forEach((item) => {
                    if (item.product.available) {
                        total += item.quantity;
                    }
                });
        } else {
            cartList &&
                cartList.forEach((item) => {
                    if (item.product.available) {
                        total += item.quantity;
                    }
                });
        }
        return total;
    };

    switchStatus = () => {
        this.setState({
            deleteStatus: !this.state.deleteStatus,
        });
    };

    handleSwitch = () => {
        this.setState({isOnlinePrice: !this.state.isOnlinePrice}, () => {
            const {sPrice} = this.props;
            let switchSelectPrice = 'switchPrice'; //切换选择价格为switchPrice,反之
            // console.log("this.state.inputdiscountCodeList======================================", this.state.inputdiscountCodeList);

            this.props.updateSwitchChoosePrice(switchSelectPrice);

            if (!(sPrice && sPrice.orderLineDetails.length >= 1)) {
                this.setState(
                    {
                        updateChoosePrice: switchSelectPrice,
                    },
                    () => {
                        this.applyCode(switchSelectPrice);
                    },
                );
            } else {
                const {cartPrice} = this.props;
                const {inputdiscountCodeList} = this.state;
                if (inputdiscountCodeList && inputdiscountCodeList.length > 1) {
                    let includeSQuote = false;
                    let includePQuote = false;
                    let includeDQuote = false;
                    let includeRQuote = false;
                    inputdiscountCodeList.length > 0 &&
                        inputdiscountCodeList.forEach((codeItem) => {
                            if (
                                codeItem
                                    .trim()
                                    .substring(0, 1)
                                    .toUpperCase() === 'S'
                            ) {
                                includeSQuote = true;
                            }
                            if (
                                codeItem
                                    .trim()
                                    .substring(0, 1)
                                    .toUpperCase() === 'P'
                            ) {
                                includePQuote = true;
                            }
                            if (
                                codeItem
                                    .trim()
                                    .substring(0, 1)
                                    .toUpperCase() === 'D'
                            ) {
                                includeDQuote = true;
                            }
                            if (
                                codeItem
                                    .trim()
                                    .substring(0, 1)
                                    .toUpperCase() === 'R'
                            ) {
                                includeRQuote = true;
                            }
                        });

                    if (includeSQuote && (includePQuote || includeDQuote)) {
                        //S + P/D调用apply 接口
                        this.setState(
                            {
                                updateChoosePrice: switchSelectPrice,
                            },
                            () => {
                                this.applyCode(switchSelectPrice);
                            },
                        );
                    } else if (includeSQuote && includeRQuote) {
                        //S + R调用apply 接口
                        this.setState(
                            {
                                updateChoosePrice: switchSelectPrice,
                            },
                            () => {
                                this.applyCode(switchSelectPrice);
                            },
                        );
                    }
                }
            }
        });
    };

    // Input Discount Change
    handleDiscountChange = (name, value) => {
        this.setState({[name]: value});
    };

    // Input quick add sku Change
    handleQuickAddSkuChange = (name, value) => {
        this.setState({[name]: value});
    };

    quickAddSkuQuantityChange = (value) => {
        if (value <= 1) {
            this.setState({
                quickAddSkuQuantity: 1,
            });
        } else {
            this.setState({
                quickAddSkuQuantity: value,
            });
        }
    };

    findMQuote = () => {
        let {inputdiscountCodeList} = this.state;
        let isApplyMQuoteFlag = false;
        let findMQuoteObj = {
            isHaveMQuote: false,
            mQuote: '',
        };
        inputdiscountCodeList &&
            inputdiscountCodeList.length > 0 &&
            inputdiscountCodeList.forEach((codeItem) => {
                if (
                    codeItem.trim().substring(0, 1).toUpperCase() ===
                    APPLY_QUOTE_TYPE.M_QUOTE
                ) {
                    findMQuoteObj.isHaveMQuote = true;
                    findMQuoteObj.mQuote = codeItem;
                }
            });
        return findMQuoteObj;
    };

    quickAddSkuHandle = () => {
        const {quickAddSkuValue, quickAddSkuQuantity} = this.state;
        const {localData} = this.props;

        if (quickAddSkuValue && quickAddSkuValue.trim()) {
            if (this.isApplyMQuote() && this.findMQuote().isHaveMQuote) {
                this.clearCode(this.findMQuote().mQuote);
            }
            this.props
                .batchAddCart([
                    {
                        productId: '',
                        customerEmail: this.getBatchAddEmail()
                            ? this.getBatchAddEmail()
                            : localData.customerEmail,
                        quantity: quickAddSkuQuantity,
                        sku: quickAddSkuValue.trim(),
                    },
                ])
                .then((res) => {
                    this.queryCart({
                        isQuickAddSkuFlag: true, //和推荐产品的行为一直，所以传true
                        num: quickAddSkuQuantity,
                        productId: '',
                    });
                    this.setState({
                        quickAddSkuQuantity: 1,
                        quickAddSkuValue: '',
                        cartUpdate: true,
                    });
                    this.props.openNotification(
                        T('quick_add_sku_success'),
                        'success',
                    );
                })
                .catch((err) => {
                    if (err.status === 'invalid_sku_price') {
                        this.props.openNotification(
                            T('notification_invalid_sku_price', [
                                quickAddSkuValue.trim(),
                            ]),
                        );
                    } else if (err.status === 'no_content') {
                        this.props.openNotification(
                            T('quickly_add_sku_no_sku', [
                                quickAddSkuValue.trim(),
                            ]),
                        );
                    } else if (err.status === 'no_sku_permission') {
                        this.props.openNotification(
                            T('other_division_no_perssion', [err.message]),
                        );
                    } else if (err.status === 'invalid_erpType') {
                        this.props.openNotification(
                            T('quickly_add_sku_is_fsbio'),
                        );
                    }
                });
        } else {
            this.props.openNotification(T('sku_is_not_null'));
        }
    };

    handleCheckLocalDataSkuPrices = (skuPrices, cartInfo) => {
        let mergeSkuPrices = [];
        let isOnlyFreeGoodCartPrice = skuPrices.filter(
            (item, freeGoodIndex) => {
                return item.freeGoodItem;
            },
        );
        let isNotFreeGoodCartPrice = skuPrices.filter((item) => {
            return !item.freeGoodItem;
        });
        let isOnlyFreeGoodCheckedCartPrice = [];
        let isNotFreeGoodCheckedCartPrice = [];
        if (typeof cartInfo.product.freeGoodItem !== 'undefined') {
            if (cartInfo.product.freeGoodItem) {
                isOnlyFreeGoodCheckedCartPrice = isOnlyFreeGoodCartPrice.filter(
                    (item) => {
                        return item.cartId === cartInfo.id;
                    },
                );
                mergeSkuPrices = [
                    ...isOnlyFreeGoodCheckedCartPrice,
                    ...isNotFreeGoodCartPrice,
                ];
            } else {
                isNotFreeGoodCheckedCartPrice = isNotFreeGoodCartPrice.filter(
                    (item) => {
                        return (
                            item.cartId !== cartInfo.id &&
                            !item.freeGoodItem ===
                                !cartInfo.product.freeGoodItem
                        );
                    },
                );
                mergeSkuPrices = [
                    ...isOnlyFreeGoodCartPrice,
                    ...isNotFreeGoodCheckedCartPrice,
                ];
            }
        } else {
            if (cartInfo.product.freeGoodItem) {
                isOnlyFreeGoodCheckedCartPrice = isOnlyFreeGoodCartPrice.filter(
                    (item) => {
                        return item.cartId !== cartInfo.id;
                    },
                );
                mergeSkuPrices = [
                    ...isOnlyFreeGoodCheckedCartPrice,
                    ...isNotFreeGoodCartPrice,
                ];
            } else {
                isNotFreeGoodCheckedCartPrice = isNotFreeGoodCartPrice.filter(
                    (item) => {
                        return (
                            item.cartId !== cartInfo.id &&
                            !item.freeGoodItem ===
                                !cartInfo.product.freeGoodItem
                        );
                    },
                );
                mergeSkuPrices = [
                    ...isOnlyFreeGoodCartPrice,
                    ...isNotFreeGoodCheckedCartPrice,
                ];
            }
        }

        return mergeSkuPrices;
    };

    getOnlyFreeGoodCartPrice = (cartPrice) => {
        let isOnlyFreeGoodCartPrice = cartPrice.data.skuPrices.filter(
            (item, freeGoodIndex) => {
                return item.freeGoodItem;
            },
        );
        return isOnlyFreeGoodCartPrice;
    };

    getNotFreeGoodCartPrice = (cartPrice) => {
        let isNotFreeGoodCartPrice = cartPrice.data.skuPrices.filter((item) => {
            return !item.freeGoodItem;
        });
        return isNotFreeGoodCartPrice;
    };

    isFreeGoodFlag = (cartInfo) => {
        let isFreeGoodFlag = false;
        if (
            typeof cartInfo.product.freeGoodItem !== 'undefined' &&
            cartInfo.product.freeGoodItem
        ) {
            isFreeGoodFlag = true;
        }
        return isFreeGoodFlag;
    };

    getCurrentCartSkuOfFreeGood = (selectedProductArray, cartInfo) => {
        let freeGoodObj = {};
        selectedProductArray.length > 0 &&
            selectedProductArray.forEach((productItem) => {
                if (
                    productItem.cartId === cartInfo.id &&
                    typeof productItem.freeGoodItem !== 'undefined' &&
                    productItem.freeGoodItem
                ) {
                    freeGoodObj = productItem;
                }
            });

        return freeGoodObj;
    };

    removeFreeGood = (selectedProductArray, cartInfo) => {
        let freeGoodObj = {};
        selectedProductArray.length > 0 &&
            selectedProductArray.forEach((productItem) => {
                if (
                    productItem.cartId === cartInfo.id &&
                    typeof productItem.freeGoodItem !== 'undefined' &&
                    productItem.freeGoodItem
                ) {
                    freeGoodObj = productItem;
                }
            });

        let notFreeGoodProcuctArry = [];
        selectedProductArray.length > 0 &&
            selectedProductArray.forEach((productItem) => {
                if (productItem.cartId !== freeGoodObj.cartId) {
                    notFreeGoodProcuctArry.push(productItem);
                }
            });
        // console.log("notFreeGoodProcuctArry=====================", notFreeGoodProcuctArry);
        return notFreeGoodProcuctArry;
    };

    getCartInfoFreeGoodInfo = (isOnlyFreeGoodCartPrice, cartInfo) => {
        let currentCartInfoFreeGood = [];
        isOnlyFreeGoodCartPrice.length > 0 &&
            isOnlyFreeGoodCartPrice.forEach((freeGoodProductItem) => {
                if (freeGoodProductItem.cartId === cartInfo.id) {
                    currentCartInfoFreeGood.push(
                        this.getSkuPriceObj(freeGoodProductItem),
                    );
                }
            });
        return currentCartInfoFreeGood;
    };

    handleSingleCheck = (flg, num, cartInfo) => {
        const {localData, cartPrice} = this.props;
        let checkNum = this.state.checkNum;
        let selectedProductArray = localData.skuPrices || [];
        let selectedDisabledProduct = this.state.disabledSelected || [];

        if (!this.state.reselectAllProductCheck) {
            this.setState({
                defaultCheck: this.state.checkAll,
            });
        } else {
            this.setState({
                defaultCheck: this.state.checkAll,
                reselectAllProductCheck: flg,
            });
        }

        console.log(
            'cartPrice==============================88888888',
            cartPrice,
        );
        console.log('cartInfo==============================cartInfo', cartInfo);
        if (flg) {
            //checked
            if (this.isApplyMQuote()) {
                //应用M quote 后，购物车中sku checked 操作
                let cartInfoFreeGoodInfo = [];
                if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
                    let isOnlyFreeGoodCartPrice =
                        this.getOnlyFreeGoodCartPrice(cartPrice);
                    let isNotFreeGoodCartPrice =
                        this.getNotFreeGoodCartPrice(cartPrice);
                    cartInfoFreeGoodInfo = this.getCartInfoFreeGoodInfo(
                        isOnlyFreeGoodCartPrice,
                        cartInfo,
                    );
                    //应用quote有值，反之
                    if (this.isFreeGoodFlag(cartInfo)) {
                        isOnlyFreeGoodCartPrice.forEach((skuPriceItem) => {
                            if (cartInfo.product.sku === skuPriceItem.sku) {
                                if (cartInfo.product.available) {
                                    cartInfo.product.finalPrice =
                                        skuPriceItem.finalPrice;
                                    cartInfo.id = skuPriceItem.cartId;
                                    if (
                                        cartPrice.data &&
                                        cartPrice.data.promoCodes.length <= 0
                                    ) {
                                        cartInfo.product.finalPrice =
                                            skuPriceItem.onlinePrice ||
                                            skuPriceItem.finalPrice;
                                    } else {
                                        cartInfo.product.finalPrice =
                                            skuPriceItem.finalPrice;
                                    }
                                }
                            }
                        });
                        console.log(
                            'handleSingleCheck===================this.state.cartProductList=============================',
                            JSON.parse(
                                JSON.stringify(this.state.cartProductList),
                            ),
                        );
                    } else {
                        isNotFreeGoodCartPrice.forEach((skuPriceItem) => {
                            if (cartInfo.product.sku === skuPriceItem.sku) {
                                if (cartInfo.product.available) {
                                    cartInfo.product.finalPrice =
                                        skuPriceItem.finalPrice;
                                    if (
                                        cartPrice.data &&
                                        cartPrice.data.promoCodes.length <= 0
                                    ) {
                                        cartInfo.product.finalPrice =
                                            skuPriceItem.onlinePrice ||
                                            skuPriceItem.finalPrice;
                                    } else {
                                        cartInfo.product.finalPrice =
                                            skuPriceItem.finalPrice;
                                    }
                                }
                            }
                        });
                    }
                }
                if (cartInfo.product.available) {
                    checkNum += parseFloat(num);
                    if (this.isFreeGoodFlag(cartInfo)) {
                        let isExist = selectedProductArray.some(
                            (skuItem) =>
                                skuItem.cartId === cartInfo.id &&
                                skuItem.freeGoodItem ===
                                    cartInfo.product.freeGoodItem,
                        );
                        if (!isExist) {
                            selectedProductArray.push({
                                cartId: cartInfo.id,
                                // finalPrice:
                                //     cartInfo.product.efPrice || cartInfo.product.finalPrice,
                                finalPrice: cartInfo.product.finalPrice,
                                quantity: parseInt(num),
                                noPromoPrice: cartInfo.product.finalPrice,
                                sku: cartInfo.product.sku,
                                productName: cartInfo.product.productName,
                                listPrice: cartInfo.product.listPrice,
                                freeGoodItem: cartInfo.product.freeGoodItem,
                            });
                        }
                    } else {
                        selectedProductArray.push({
                            cartId: cartInfo.id,
                            // finalPrice:
                            //     cartInfo.product.efPrice || cartInfo.product.finalPrice,
                            finalPrice: cartInfo.product.finalPrice,
                            quantity: parseInt(num),
                            noPromoPrice: cartInfo.product.finalPrice,
                            sku: cartInfo.product.sku,
                            productName: cartInfo.product.productName,
                            listPrice: cartInfo.product.listPrice,
                            freeGoodItem: cartInfo.product.freeGoodItem,
                        });
                        selectedProductArray = [
                            ...selectedProductArray,
                            ...cartInfoFreeGoodInfo,
                        ];
                    }
                } else {
                    selectedDisabledProduct.push({
                        cartId: cartInfo.id,
                        quantity: cartInfo.quantity,
                    });
                }

                let tempFreeGoodObj = this.getCurrentCartSkuOfFreeGood(
                    selectedProductArray,
                    cartInfo,
                );
                if (
                    checkNum > 0 &&
                    tempFreeGoodObj &&
                    typeof tempFreeGoodObj.quantity !== 'undefined'
                ) {
                    checkNum += parseFloat(tempFreeGoodObj.quantity);
                }
            } else {
                if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
                    //应用quote有值，反之
                    cartPrice.data.skuPrices.forEach((skuPriceItem) => {
                        if (cartInfo.product.sku === skuPriceItem.sku) {
                            if (cartInfo.product.available) {
                                cartInfo.product.finalPrice =
                                    skuPriceItem.finalPrice;
                                if (
                                    cartPrice.data &&
                                    cartPrice.data.promoCodes.length <= 0
                                ) {
                                    cartInfo.product.finalPrice =
                                        skuPriceItem.onlinePrice ||
                                        skuPriceItem.finalPrice;
                                } else {
                                    cartInfo.product.finalPrice =
                                        skuPriceItem.finalPrice;
                                }
                            }
                        }
                    });
                }
                if (cartInfo.product.available) {
                    checkNum += parseFloat(num);
                    selectedProductArray.push({
                        cartId: cartInfo.id,
                        finalPrice:
                            cartInfo.product.efPrice ||
                            cartInfo.product.finalPrice,
                        quantity: parseInt(num),
                        noPromoPrice: cartInfo.product.finalPrice,
                        sku: cartInfo.product.sku,
                        productName: cartInfo.product.productName,
                        listPrice: cartInfo.product.listPrice,
                    });
                } else {
                    selectedDisabledProduct.push({
                        cartId: cartInfo.id,
                        quantity: cartInfo.quantity,
                    });
                }
            }
        } else {
            //unchecked
            if (cartInfo.product.available) {
                if (checkNum > 0) {
                    checkNum -= parseFloat(num);
                }

                if (this.isApplyMQuote()) {
                    //应用M quote 后，skuPrices的维护
                    selectedProductArray = this.handleCheckLocalDataSkuPrices(
                        localData.skuPrices,
                        cartInfo,
                    ); //过滤掉当前cartInfo
                    let tempFreeGoodObj = this.getCurrentCartSkuOfFreeGood(
                        selectedProductArray,
                        cartInfo,
                    );

                    //如果当前cartInfo有赠品，则过滤掉赠品
                    selectedProductArray = this.removeFreeGood(
                        selectedProductArray,
                        cartInfo,
                    );

                    if (
                        checkNum > 0 &&
                        tempFreeGoodObj &&
                        typeof tempFreeGoodObj.quantity !== 'undefined'
                    ) {
                        checkNum -= parseFloat(tempFreeGoodObj.quantity);
                    }
                } else {
                    selectedProductArray = localData.skuPrices.filter(
                        (item) => {
                            return item.cartId !== cartInfo.id;
                        },
                    );
                }
            } else {
                selectedDisabledProduct = selectedDisabledProduct.filter(
                    (item) => {
                        return item.cartId !== cartInfo.id;
                    },
                );
                this.setState({
                    disabledSelected: selectedDisabledProduct,
                });
            }
        }

        if (this.isApplyMQuote()) {
            this.props.setCartDetails({
                skuPrices: selectedProductArray,
            });
        } else {
            this.changeSelectProductDetails(selectedProductArray, true);
        }

        this.setState({
            checkNum: checkNum,
            cartUpdate: true,
        });
    };

    isInitCartData = () => {
        const {localData, cartPrice} = this.props;
        let isInitCartFlag = false;
        if (
            cartPrice.status !== 'success' &&
            cartPrice.status !== 'cmgt_error'
        ) {
            if (cartPrice.data && cartPrice.data.promoCodes.length < 1) {
                if (localData) {
                    isInitCartFlag = true;
                }
            }
        }
        return isInitCartFlag;
    };

    changeNum = (cartInfo, num, isAddReduStatus) => {
        console.log('changeNum=====================================', num);
        if (this.isChoosePrice()) {
            //改变购物车数量时，如果前一个步骤是切换选择价格时，清空表示切换选择价格的变量
            this.setState({
                updateChoosePrice: '',
            });
        }
        if (num) {
            this.props
                .sumbitQuantity({
                    id: cartInfo.id,
                    quantity: num,
                })
                .then((res) => {
                    this.getCart(res, cartInfo);
                    if (num && cartInfo) {
                        this.changeTypeMessage(cartInfo, num);
                    }
                });
        }
    };

    changeTypeMessage = (cartInfo, num) => {
        let tempCartProductList = JSON.parse(
            JSON.stringify(this.state.cartProductList),
        );
        tempCartProductList.length > 0 &&
            tempCartProductList.forEach((cartData, cartDataIndex) => {
                if (
                    cartData.product.productAttr === 'sc_black' &&
                    cartInfo.sku === cartData.sku
                ) {
                    if (num > cartData.product.inventory) {
                        if (cartData.product.type === 1) {
                            cartData.product.type = 2;
                            this.props.openNotification(
                                T('scChangeTfsTypeMessage', [cartInfo.sku]),
                            );
                        }
                    } else {
                        cartData.product.type = 1;
                    }
                }
            });
        console.log(
            'cartProductList==========================================111',
            tempCartProductList,
        );
        this.setState({
            cartProductList: tempCartProductList,
        });
    };

    isExistSkuItem = (skuPrices) => {
        let tempSkuPricesList = [];
        skuPrices.length > 0 &&
            skuPrices.map((skuPrice, skuPriceIndex) => {
                let isExist = skuPrices.some(
                    (skuItem) =>
                        skuItem.cartId === skuPrice.cartId &&
                        !skuItem.freeGoodItem === !skuPrice.freeGoodItem,
                );
                if (!isExist) {
                    tempSkuPricesList.push(skuPrice);
                }
            });
        return tempSkuPricesList;
    };

    getTotalPrice = (skuPrices) => {
        const {isOnlinePrice, sQuote, applyQuoteOperation, updateChoosePrice} =
            this.state;
        const {sPrice, cartPrice, cartList} = this.props;

        // OEM 产品无线上价格，保留勾选与结算行为，但不参与金额计算。
        skuPrices = (skuPrices || []).filter((skuPrice) => {
            const cartItem = (cartList || []).find(
                (item) => item.id === skuPrice.cartId,
            );
            return !this.isOemCart(cartItem);
        });

        let priceA = 0.0;
        let priceB = 0.0;
        let tempPriceA = 0.0;
        let tempPriceB = 0.0;

        let total = 0.0;

        // console.log("1===================================", this.state.applyQuoteOperation);
        console.log(skuPrices, '===================================skuPrices');
        // console.log(cartPrice, "===================================cartPrice");
        // console.log(cartList, "===================================cartList");
        if (typeof cartList !== 'undefined') {
            let haveSQuoteSkuPrices = [];
            if (skuPrices && skuPrices.length > 0) {
                skuPrices.forEach((skuPItem) => {
                    cartList &&
                        cartList.length > 0 &&
                        cartList.forEach((cartItem) => {
                            if (
                                skuPItem.sku === cartItem.sku &&
                                skuPItem.cartId &&
                                cartItem.id === skuPItem.cartId
                            ) {
                                if (typeof skuPItem.quantity === 'undefined') {
                                    skuPItem.quantity = cartItem.quantity;
                                }
                                if (
                                    cartPrice.status !== 'success' &&
                                    cartPrice.status !== 'cmgt_error'
                                ) {
                                    if (
                                        cartPrice.data &&
                                        cartPrice.data.promoCodes.length < 1
                                    ) {
                                        if (!this.isChoosePrice()) {
                                            if (isOnlinePrice) {
                                                skuPItem.finalPrice =
                                                    cartItem.product
                                                        .onlinePrice ||
                                                    cartItem.product.finalPrice;
                                                skuPItem.noPromoPrice =
                                                    skuPItem.finalPrice;
                                            } else {
                                                skuPItem.finalPrice =
                                                    cartItem.product.efPrice ||
                                                    cartItem.product.finalPrice;
                                                skuPItem.noPromoPrice =
                                                    skuPItem.finalPrice;
                                            }
                                        } else {
                                            let currentSkuPriceObj =
                                                this.getCurrentSkuPriceObj(
                                                    skuPItem.sku,
                                                    cartPrice,
                                                );
                                            if (
                                                JSON.stringify(
                                                    currentSkuPriceObj,
                                                ) !== '{}' &&
                                                currentSkuPriceObj.cartId
                                            ) {
                                                if (isOnlinePrice) {
                                                    skuPItem.finalPrice =
                                                        currentSkuPriceObj.onlinePrice ||
                                                        currentSkuPriceObj.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                } else {
                                                    skuPItem.finalPrice =
                                                        currentSkuPriceObj.efPrice ||
                                                        currentSkuPriceObj.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                }
                                            }
                                        }
                                    } else if (
                                        cartPrice.data &&
                                        cartPrice.data.promoCodes.length === 1
                                    ) {
                                        if (this.isChoosePrice()) {
                                            //D + R 从折扣价到最优价切换，R失败，D成功，用后端的单价
                                            let currentSkuPriceObj =
                                                this.getCurrentSkuPriceObj(
                                                    skuPItem.sku,
                                                    cartPrice,
                                                );
                                            if (
                                                JSON.stringify(
                                                    currentSkuPriceObj,
                                                ) !== '{}' &&
                                                currentSkuPriceObj.cartId
                                            ) {
                                                console.log(
                                                    'currentSkuPriceObj8888888888888888888888888888888888888888888888',
                                                    currentSkuPriceObj,
                                                );
                                                if (
                                                    cartPrice.data.promoCodes[0]
                                                        .substring(0, 1)
                                                        .toUpperCase() === 'S'
                                                ) {
                                                    if (isOnlinePrice) {
                                                        skuPItem.finalPrice =
                                                            currentSkuPriceObj.onlinePrice ||
                                                            currentSkuPriceObj.finalPrice;
                                                        skuPItem.noPromoPrice =
                                                            skuPItem.finalPrice;
                                                    } else {
                                                        skuPItem.finalPrice =
                                                            currentSkuPriceObj.efPrice ||
                                                            currentSkuPriceObj.finalPrice;
                                                        skuPItem.noPromoPrice =
                                                            skuPItem.finalPrice;
                                                    }
                                                } else {
                                                    skuPItem.finalPrice =
                                                        currentSkuPriceObj.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                }
                                            }
                                        } else {
                                            let currentSkuPriceObj =
                                                this.getCurrentSkuPriceObj(
                                                    skuPItem.sku,
                                                    cartPrice,
                                                );
                                            if (
                                                cartPrice.data.promoCodes[0]
                                                    .substring(0, 1)
                                                    .toUpperCase() === 'S'
                                            ) {
                                                if (isOnlinePrice) {
                                                    skuPItem.finalPrice =
                                                        currentSkuPriceObj.onlinePrice ||
                                                        currentSkuPriceObj.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                } else {
                                                    skuPItem.finalPrice =
                                                        currentSkuPriceObj.efPrice ||
                                                        currentSkuPriceObj.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                }
                                            } else {
                                                if (isOnlinePrice) {
                                                    skuPItem.finalPrice =
                                                        skuPItem.onlinePrice ||
                                                        skuPItem.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                } else {
                                                    skuPItem.finalPrice =
                                                        cartItem.product
                                                            .efPrice ||
                                                        cartItem.product
                                                            .finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                }
                                            }
                                        }

                                        if (
                                            typeof skuPItem.staticQuoteType !==
                                                'undefined' &&
                                            !skuPItem.staticQuoteType
                                        ) {
                                            haveSQuoteSkuPrices.push(skuPItem);
                                        }
                                    }
                                } else if (cartPrice.status === 'success') {
                                    if (
                                        cartPrice.data &&
                                        cartPrice.data.promoCodes.length < 1
                                    ) {
                                        if (isOnlinePrice) {
                                            skuPItem.finalPrice =
                                                cartItem.product.onlinePrice ||
                                                cartItem.product.finalPrice;
                                            skuPItem.noPromoPrice =
                                                skuPItem.finalPrice;
                                        } else {
                                            skuPItem.finalPrice =
                                                cartItem.product.efPrice ||
                                                cartItem.product.finalPrice;
                                            skuPItem.noPromoPrice =
                                                skuPItem.finalPrice;
                                        }
                                    } else if (
                                        cartPrice.data &&
                                        cartPrice.data.promoCodes.length === 1
                                    ) {
                                        if (
                                            cartPrice.data.promoCodes[0]
                                                .substring(0, 1)
                                                .toUpperCase() === 'S'
                                        ) {
                                            if (this.isChoosePrice()) {
                                                if (isOnlinePrice) {
                                                    skuPItem.finalPrice =
                                                        cartItem.product
                                                            .onlinePrice ||
                                                        cartItem.product
                                                            .finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                } else {
                                                    skuPItem.finalPrice =
                                                        cartItem.product
                                                            .efPrice ||
                                                        cartItem.product
                                                            .finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                }
                                            } else {
                                                let currentSkuPriceObj =
                                                    this.getCurrentSkuPriceObj(
                                                        skuPItem.sku,
                                                        cartPrice,
                                                    );

                                                if (isOnlinePrice) {
                                                    skuPItem.finalPrice =
                                                        currentSkuPriceObj.onlinePrice ||
                                                        currentSkuPriceObj.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                } else {
                                                    skuPItem.finalPrice =
                                                        currentSkuPriceObj.efPrice ||
                                                        currentSkuPriceObj.finalPrice;
                                                    skuPItem.noPromoPrice =
                                                        skuPItem.finalPrice;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        });
                });
            }
            if (haveSQuoteSkuPrices.length > 0) {
                skuPrices = haveSQuoteSkuPrices;
            }
        }
        console.log(
            skuPrices,
            '===============After====================skuPrices',
        );

        if (cartPrice.status !== 'cmgt_error') {
            if (skuPrices && skuPrices.length > 1) {
                total = skuPrices.reduce((first, second) => {
                    tempPriceA = isOnlinePrice
                        ? first.noPromoPrice
                        : first.finalPrice;
                    tempPriceB = isOnlinePrice
                        ? second.noPromoPrice
                        : second.finalPrice;
                    // console.log('first===================================', first);
                    // console.log(
                    //     'second===================================',
                    //     second,
                    // );
                    // console.log(
                    //     'tempPriceA===================================',
                    //     tempPriceA,
                    // );
                    // console.log(
                    //     'tempPriceB===================================',
                    //     tempPriceB,
                    // );

                    priceA = tempPriceA
                        ? tempPriceA * first.quantity
                        : parseFloat(first);
                    priceB = tempPriceB * second.quantity;

                    return util.toMoney(priceA + priceB);
                });
            } else if (skuPrices && skuPrices.length === 1) {
                // console.log(
                //     'skuPrices[0]===================================',
                //     skuPrices[0],
                // );
                // console.log('ddd111111111111111111111111111111111111111111111');
                total = isOnlinePrice
                    ? util.toMoney(
                          skuPrices[0].noPromoPrice * skuPrices[0].quantity,
                      )
                    : util.toMoney(
                          skuPrices[0].finalPrice * skuPrices[0].quantity,
                      );
            }

            if (sQuote) {
                sPrice &&
                    sPrice.orderLineDetails &&
                    sPrice.orderLineDetails.forEach((item) => {
                        total =
                            parseFloat(total) + parseFloat(item.extendedPrice);
                    });
            }

            return util.toMoney(total);
        }
    };

    isChoosePrice = () => {
        let isChoosePriceFlag = false;
        const {updateChoosePrice} = this.state;
        if (
            typeof updateChoosePrice !== 'undefined' &&
            updateChoosePrice &&
            updateChoosePrice === 'switchPrice'
        ) {
            isChoosePriceFlag = true;
        }
        return isChoosePriceFlag;
    };

    getCurrentSkuPriceObj = (sku, cartPrice) => {
        let skuP = {};
        if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
            cartPrice.data.skuPrices.forEach((skuItem) => {
                if (skuItem.sku === sku && skuItem.cartId) {
                    skuP = skuItem;
                }
            });
        }
        return skuP;
    };

    deleteItem = () => {
        const {localData} = this.props;
        const {disabledSelected} = this.state;
        let cartIds = [];

        if (localData.skuPrices.length !== 0 || disabledSelected.length !== 0) {
            cartIds = localData.skuPrices.map((item) => {
                return item.cartId;
            });

            cartIds = cartIds.concat(
                disabledSelected.map((item) => {
                    return item.cartId;
                }),
            );

            //SCME-4048
            if (this.isApplyMQuote() && this.findMQuote().isHaveMQuote) {
                this.clearCode(this.findMQuote().mQuote);
            }

            this.props
                .deleteCart({
                    ids: cartIds,
                    customerEmail: localData.customerEmail
                        ? localData.customerEmail
                        : this.getBatchAddEmail(),
                })
                .then((res) => {
                    this.props.setCartDetails({
                        skuPrices: [],
                    });
                    res.isAddRecommendedFlag = false;
                    res.deleteSkuFlag = true;
                    this.queryCart(res);
                    if (
                        res.cartCount === 0 &&
                        this.state.inputdiscountCodeList.length > 0
                    ) {
                        this.clearSquote();
                        this.setState({
                            inputdiscountCodeList: [],
                        });
                    }
                });
        }

        this.setState({cartUpdate: true});
    };

    queryCart = (params, switchSelectPrice) => {
        const {localData} = this.props;

        let shipToNumber = util.getShipToNumber(localData);

        let queryCartParams = {};
        if (this.getBatchAddShipTo()) {
            queryCartParams = {
                customerEmail: this.getBatchAddEmail(),
                supplyCenterId: NO_SUPPLY_CENTER_ID,
                shipToNumber: this.getBatchAddShipTo(),
                purchaseOrderMode: util.getPurchaseOrderMode(),
            };
        } else {
            queryCartParams = {
                customerEmail:
                    params && params.cusomerEmail
                        ? params.cusomerEmail
                        : localData.customerEmail,
                supplyCenterId:
                    params && params.scId
                        ? params.scId
                        : localData.scId
                        ? localData.scId
                        : localData.defaultScId
                        ? localData.defaultScId
                        : NO_SUPPLY_CENTER_ID,
                shipToNumber:
                    params && params.shipToNum
                        ? params.shipToNum
                        : shipToNumber,
                purchaseOrderMode: util.getPurchaseOrderMode(),
            };
        }
        this.props.queryCart(queryCartParams, this.cartLoading).then((res) => {
            if (res) {
                this.state.initial &&
                    this.handleCheck({
                        target: {
                            checked: true,
                        },
                    });

                if (
                    !(
                        params &&
                        typeof params.isAddAssayidFlag !== 'undefined' &&
                        params.isAddAssayidFlag
                    )
                ) {
                    localStorage.setItem('changSkuTypeList', []);
                }
                let currentCartProductList = JSON.parse(
                    JSON.stringify(res.data),
                );
                let updateCartList = this.updateProductType(res.data);

                let currentIsOnlinePrice = false;
                if (
                    params &&
                    typeof params.isAddRecommendedFlag !== 'undefined' &&
                    params.isAddRecommendedFlag
                ) {
                    currentIsOnlinePrice = this.state.isOnlinePrice;
                } else if (
                    params &&
                    typeof params.isQuickAddSkuFlag !== 'undefined' &&
                    params.isQuickAddSkuFlag
                ) {
                    currentIsOnlinePrice = this.state.isOnlinePrice;
                } else if (
                    typeof switchSelectPrice !== 'undefined' &&
                    switchSelectPrice &&
                    switchSelectPrice === 'switchPrice'
                ) {
                    currentIsOnlinePrice = this.state.isOnlinePrice;
                } else {
                    if (typeof params === 'undefined') {
                        currentIsOnlinePrice = this.checkWebOnlyPrice(res.data)
                            ? true
                            : false;
                    } else {
                        currentIsOnlinePrice = this.checkWebOnlyPrice(res.data)
                            ? this.checkWebOnlyPrice(res.data)
                            : false;
                    }
                }

                this.setState({
                    initial: false,
                    isOnlinePrice: currentIsOnlinePrice,
                    cartProductList: updateCartList,
                    originalCartProductList: currentCartProductList,
                    changeSkuList: [],
                });
                this.getQuote(updateCartList.map((item) => item.sku));
                if (
                    params &&
                    typeof params.isAddRecommendedFlag !== 'undefined' &&
                    params.isAddRecommendedFlag
                ) {
                    this.updateTotalPriceAndCheckNum(res, localData, params);
                } else if (
                    params &&
                    typeof params.isQuickAddSkuFlag !== 'undefined' &&
                    params.isQuickAddSkuFlag
                ) {
                    this.updateTotalPriceAndCheckNum(res, localData, params);
                }

                let skuArr = [];
                res.data.map((item) => {
                    if (item.product.type === 2) {
                        skuArr.push(item.product.sku);
                    }

                    return null;
                });

                if (skuArr.length > 0) {
                    this.queryEoneInventory(skuArr);
                }
            }
        });
    };

    updateProductType = (cartData) => {
        cartData.length > 0 &&
            cartData.forEach((currentCartData, currentCartDataIndex) => {
                if (
                    currentCartData.quantity >
                        currentCartData.product.inventory &&
                    currentCartData.product.productAttr === 'sc_black'
                ) {
                    currentCartData.product.type = 2;
                }
            });
        return cartData;
    };

    updateTotalPriceAndCheckNum = (res, localData, params) => {
        const {cartPrice} = this.props;
        let allProducts = res.data;
        let currentAddProduct = '';
        let checkNum = this.state.checkNum;
        for (let k = 0; k < res.data.length; k++) {
            checkNum += res.data[k].quantity;
            if (res.data[k].product.id === params.productId) {
                currentAddProduct = res.data[k];
            }
        }

        let allSkuPrices = localData.skuPrices;
        let addRecommendedProduct = allProducts.filter(
            (item) => !allSkuPrices.some((ele) => ele.cartId === item.id),
        );
        let shoppingCartProductArr = [];

        for (let i = 0; i < addRecommendedProduct.length; i++) {
            console.log('eee111111111111111111111111111111111111111111111');
            let currentRecommendedProduct = {
                cartId: addRecommendedProduct[0].id,
                finalPrice:
                    addRecommendedProduct[i].product.efPrice ||
                    addRecommendedProduct[i].product.finalPrice,
                quantity: params.num,
                noPromoPrice: addRecommendedProduct[i].product.finalPrice,
                sku: addRecommendedProduct[i].product.sku,
                productName: addRecommendedProduct[i].product.productName,
                listPrice: addRecommendedProduct[i].product.listPrice,
            };
            shoppingCartProductArr.push(currentRecommendedProduct);
        }

        for (let j = 0; j < localData.skuPrices.length; j++) {
            let currentSkuPriceObj = JSON.parse(
                JSON.stringify(localData.skuPrices[j]),
            );
            if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
                currentSkuPriceObj.noPromoPrice = currentSkuPriceObj.finalPrice;
            }
            shoppingCartProductArr.push(currentSkuPriceObj);
        }

        console.log(
            'setCartDetails========skuPrices111111',
            shoppingCartProductArr,
        );
        console.log(
            'setCartDetails===========================================================11',
        );
        this.props.setCartDetails({
            skuPrices: shoppingCartProductArr,
        });

        this.handleCheck({
            target: {
                checked: true,
            },
        });

        this.setState({
            checkNum: checkNum,
            reselectAllProductCheck: true,
        });

        if (
            !(
                (params.deleteSkuFlag !== undefined && params.deleteSkuFlag) ||
                (params.isQuickAddSkuFlag !== undefined &&
                    params.isQuickAddSkuFlag)
            )
        ) {
            this.props.openNotification(
                T('shopping_cart_add_hot_recommended'),
                'success',
            );
        }
    };

    queryEoneInventory = (params) => {
        this.props.queryEoneInventory({skuList: params}).then((res) => {
            if (res) {
                let arr = this.state.cartProductList.concat();
                arr.map((obj) => {
                    res.data.map((item) => {
                        if (item.sku === obj.product.sku) {
                            obj.product.availableInventory = parseInt(
                                item.availableInventory,
                            );
                        }

                        return null;
                    });

                    return null;
                });

                console.log(
                    'cartProductList==========================================333',
                    arr,
                );
                this.setState({
                    cartProductList: arr,
                });
            }
        });
    };

    cartLoading = (res) => {
        this.setState({
            checkNum: 0,
        });
    };

    changeNumUpdateLocalSkuPriceQuantity = (changeNumRes) => {
        const {localData, cartPrice} = this.props;
        const {isOnlinePrice} = this.state;
        let selectedProductArray = localData.skuPrices || [];

        if (selectedProductArray) {
            selectedProductArray.forEach((skuItem) => {
                if (changeNumRes.data.id === skuItem.cartId) {
                    skuItem.quantity = changeNumRes.data.quantity;
                }
            });
        }

        if (selectedProductArray.length > 0) {
            selectedProductArray.forEach((skuPriceItem) => {
                if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
                    cartPrice.data.skuPrices.forEach((cartPriceItem) => {
                        if (
                            cartPriceItem.cartId &&
                            skuPriceItem.cartId === cartPriceItem.cartId
                        ) {
                            skuPriceItem.listPrice = cartPriceItem.listPrice;
                            skuPriceItem.finalPrice = isOnlinePrice
                                ? cartPriceItem.onlinePrice ||
                                  cartPriceItem.finalPrice
                                : cartPriceItem.efPrice ||
                                  cartPriceItem.finalPrice;
                            skuPriceItem.noPromoPrice = skuPriceItem.finalPrice;
                        }
                    });
                }
            });
        }

        console.log(
            'setCartDetails===========================================================22',
        );
        this.props.setCartDetails({
            skuPrices: selectedProductArray,
        });
    };

    changeNumUpdateTotalCount = (quantity, cartInfo) => {
        const {localData, cartPrice} = this.props;
        let currentSkuPrices = JSON.parse(JSON.stringify(localData.skuPrices));
        let tempSkuPrices = [];

        if (currentSkuPrices.length > 0) {
            let isOnlyFreeGoodCartList = currentSkuPrices.filter(
                (item, freeGoodIndex) => {
                    return item.freeGoodItem;
                },
            );
            let isNotFreeGoodCartList = currentSkuPrices.filter(
                (item, notFreeGoodIndex) => {
                    return !item.freeGoodItem;
                },
            );
            isNotFreeGoodCartList.length > 0 &&
                isNotFreeGoodCartList.map((skuItem) => {
                    if (
                        skuItem.cartId === cartInfo.id &&
                        !skuItem.freeGoodItem
                    ) {
                        skuItem.quantity = quantity;
                    }
                });
            tempSkuPrices = [
                ...isNotFreeGoodCartList,
                ...isOnlyFreeGoodCartList,
            ];
        }

        return tempSkuPrices;
    };

    changeNumberUpdateCartProductList = (quantity, cartInfo) => {
        const {cartProductList} = this.state;
        let currentCartProductList = JSON.parse(
            JSON.stringify(cartProductList),
        );
        let tempCartProductList = [];

        if (currentCartProductList.length > 0) {
            let isOnlyFreeGoodCartList = currentCartProductList.filter(
                (item, freeGoodIndex) => {
                    return item.product.freeGoodItem;
                },
            );
            let isNotFreeGoodCartList = currentCartProductList.filter(
                (item) => {
                    return !item.product.freeGoodItem;
                },
            );
            isNotFreeGoodCartList.length > 0 &&
                isNotFreeGoodCartList.map((skuItem) => {
                    if (
                        skuItem.id === cartInfo.id &&
                        !skuItem.product.freeGoodItem
                    ) {
                        skuItem.quantity = quantity;
                    }
                });

            tempCartProductList = isNotFreeGoodCartList;
            isOnlyFreeGoodCartList.length > 0 &&
                isOnlyFreeGoodCartList.map((freedGood) => {
                    tempCartProductList.splice(
                        freedGood.indexNumber,
                        0,
                        freedGood,
                    );
                });
        }

        return tempCartProductList;
    };

    getCart = (res, cartInfo) => {
        const {localData, cartPrice} = this.props;
        let checkNum = 0;
        let shipToNumber = util.getShipToNumber(localData);

        if (this.choosePriceOnlySQuoteSuccess()) {
            this.changeNumUpdateLocalSkuPriceQuantity(res); //res是更改购物车数量的返回结果
        } else if (this.isApplyMQuote() && !this.isChoosePrice()) {
            let tempSkuPrices = this.changeNumUpdateTotalCount(
                res.data.quantity,
                cartInfo,
            );
            let tempCartProductList = this.changeNumberUpdateCartProductList(
                res.data.quantity,
                cartInfo,
            );

            this.setState({
                cartProductList: tempCartProductList,
            });
            this.props.setCartDetails({
                skuPrices: tempSkuPrices,
            });

            tempSkuPrices.length > 0 &&
                tempSkuPrices.forEach((item) => {
                    checkNum += item.quantity;
                });
        } else {
            this.changeSelectProductDetails([
                {
                    quantity: res.data.quantity,
                    cartId: res.data.id,
                },
            ]);
        }
        if (!(this.isApplyMQuote() && !this.isChoosePrice())) {
            localData.skuPrices &&
                localData.skuPrices.forEach((item) => {
                    checkNum += item.quantity;
                });
        }

        this.setState({
            checkNum: checkNum,
        });

        let cartParams = {};
        if (this.getBatchAddShipTo()) {
            cartParams = {
                customerEmail: this.getBatchAddEmail(),
                supplyCenterId: NO_SUPPLY_CENTER_ID,
                shipToNumber: this.getBatchAddShipTo(),
                purchaseOrderMode: util.getPurchaseOrderMode(),
            };
        } else {
            cartParams = {
                customerEmail: localData.customerEmail,
                supplyCenterId: localData.scId
                    ? localData.scId
                    : localData.defaultScId
                    ? localData.defaultScId
                    : NO_SUPPLY_CENTER_ID,
                shipToNumber: shipToNumber,
                purchaseOrderMode: util.getPurchaseOrderMode(),
            };
        }
        console.log(
            'getCart================localData.skuPrices=========================================',
            localData.skuPrices,
        );
        if (
            !(this.onlySQuoteSuccess() || this.choosePriceOnlySQuoteSuccess())
        ) {
            this.props.queryCart(cartParams).then((res) => {
                if (
                    res &&
                    res.status === 'success' &&
                    Array.isArray(res.data)
                ) {
                    const latestCartProductList = this.updateProductType(
                        JSON.parse(JSON.stringify(res.data)),
                    );
                    this.setState({
                        cartProductList: latestCartProductList,
                    });
                }
            });
        }
    };

    choosePriceOnlySQuoteSuccess = () => {
        const {cartPrice} = this.props;
        const {updateChoosePrice} = this.state;
        let isClearFlag = false;
        if (
            cartPrice.status !== 'cmgt_error' &&
            cartPrice.status !== 'success' &&
            cartPrice.data &&
            cartPrice.data.promoCodes.length === 1
        ) {
            if (
                cartPrice.data.promoCodes[0].substring(0, 1).toUpperCase() ===
                    'S' ||
                !updateChoosePrice
            ) {
                isClearFlag = true;
            }
        }
        return isClearFlag;
    };

    onlySQuoteSuccess = () => {
        const {cartPrice} = this.props;
        const {updateChoosePrice} = this.state;
        let isClearFlag = false;
        if (
            cartPrice.status === 'success' &&
            cartPrice.data &&
            cartPrice.data.promoCodes.length === 1
        ) {
            if (
                cartPrice.data.promoCodes[0].substring(0, 1).toUpperCase() ===
                    'S' ||
                !updateChoosePrice
            ) {
                isClearFlag = true;
            }
        }
        return isClearFlag;
    };

    clearCodeSuccess = () => {
        const {cartPrice} = this.props;
        let isClearFlag = false;
        if (
            cartPrice.status === 'success' &&
            cartPrice.data &&
            cartPrice.data.promoCodes.length === 0
        ) {
            isClearFlag = true;
        }
        return isClearFlag;
    };

    showAssayIdContent = (cartProductList) => {
        let isShowAssayIdContent = true;
        cartProductList &&
            cartProductList.length > 0 &&
            cartProductList.map((cartItem, cartIndex) => {
                if (
                    cartItem.assayIdRequired &&
                    (typeof cartItem.displayAttributeList === 'undefined' ||
                        !cartItem.displayAttributeList)
                ) {
                    isShowAssayIdContent = false;
                }
            });

        return isShowAssayIdContent;
    };

    goToOrderConfirmation = () => {
        const {localData} = this.props;
        const {
            inputdiscountCodeList,
            isOnlinePrice,
            sQuote,
            cartUpdate,
            cartProductList,
        } = this.state;
        let cartIds = [];
        let shipToNumber = util.getShipToNumber(localData);
        let msg = '';
        let isUseMQuote = this.isApplyMQuote();

        cartIds = localData.skuPrices.map((item) => {
            return item.cartId;
        });

        const selectedCartList = cartProductList.filter((item) =>
            cartIds.includes(item.id),
        );
        if (!this.showAssayIdContent(selectedCartList)) {
            this.props.openNotification(T('shopping_cart_empty_assayId'));
            return false;
        }

        if ((cartIds && cartIds.length > 0) || sQuote) {
            window.scrollTo(0, 0);
            this.setState({
                pageLoading: true,
            });

            if (
                localData.orderNumbers &&
                localData.orderNumbers.length > 0 &&
                !cartUpdate &&
                !isUseMQuote &&
                this.isCheckAll()
            ) {
                this.disableOverFlow(false);

                let purchaseOrderMode = undefined;
                let routerState = util.getRouterState(
                    this.props.history.location.state,
                );
                if (JSON.stringify(routerState) !== '{}') {
                    purchaseOrderMode = routerState.purchaseOrderMode;
                }

                localStorage.setItem('offlineOrderCredential', []);
                this.props.history.push('/purchase/orderConfirmation', {
                    customerEmail: util.getPurchaseCustomerEmail(),
                    customerName: util.getPurchaseCustomerName(),
                });
            } else {
                let checkedSipTypes = this.getCheckedSipTypes(cartIds);
                let typeList = this.getShippingType(checkedSipTypes);
                // console.log(typeList);
                let goOrderParams = {};
                if (this.getBatchAddShipTo()) {
                    goOrderParams = {
                        priceType: isOnlinePrice ? 2 : 1,
                        promoCodes: inputdiscountCodeList,
                        shipToNum: this.getBatchAddShipTo(),
                        cartIds: cartIds,
                        generateE1Order: true, //调试时放开
                        supplyCenterId: NO_SUPPLY_CENTER_ID,
                        customerEmail: this.getBatchAddEmail(),
                        shipTypes: typeList,
                    };
                } else {
                    goOrderParams = {
                        priceType: isOnlinePrice ? 2 : 1,
                        promoCodes: inputdiscountCodeList,
                        shipToNum: shipToNumber,
                        cartIds: cartIds,
                        generateE1Order: true,
                        supplyCenterId: localData.scId
                            ? localData.scId
                            : localData.defaultScId
                            ? localData.defaultScId
                            : NO_SUPPLY_CENTER_ID,
                        customerEmail: localData.customerEmail,
                        shipTypes: typeList,
                    };
                }

                if (this.isApplyMQuote()) {
                    goOrderParams.shipTypes =
                        this.switchChoosePriceGetShipTypes();
                    const tempCarIds = [...new Set(goOrderParams.cartIds)];
                    goOrderParams.cartIds = tempCarIds;
                }
                this.props
                    .calculatePrice(goOrderParams)
                    .then((res) => {
                        this.generateDraftOrder(
                            res,
                            isOnlinePrice ? 2 : 1,
                            true,
                            isUseMQuote,
                        );
                        this.setState({pageLoading: false});
                        this.disableOverFlow(false);
                    })
                    .catch((err) => {
                        if (
                            isUseMQuote &&
                            err.status !== 'oem_mixed_checkout_not_supported'
                        ) {
                            this.applyMQuoteFailedChangeSkuType();
                        }
                        if (err.status !== 'cmgt_error') {
                            if (
                                err.status ===
                                'oem_mixed_checkout_not_supported'
                            ) {
                                msg = T('oem_mixed_checkout_not_supported');
                            } else if (
                                err.status === 'error_promo_code' ||
                                err.status === 'error_price'
                            ) {
                                msg = T('shopping_cart_apply_failure');
                            } else if (err.status === 'invalid_quote') {
                                msg = T('notification_order_promo_invalid');
                            } else if (err.status === 'expired_quote') {
                                msg = T(
                                    'notification_order_promo_not_active_or_expired',
                                );
                            } else if (err.status === 'mismatch_quote') {
                                msg = this.getMismatchQuoteDataMessage(err);
                            } else if (err.status === 'po_failed') {
                                msg = T('notification_order_generation_failed');
                            } else if (err.status === 'Invalid_ShipTo') {
                                msg = T('notification_invalid_st_or_bt');
                            } else if (err.status !== 'cmgt_error') {
                                msg = T('notification_order_promo_failed');
                            } else if (
                                err.status === 'invalid_combination_quote'
                            ) {
                                msg = T(
                                    'notification_invalid_combination_quote',
                                );
                            } else if (
                                !err.status &&
                                err.data &&
                                err.data.promos &&
                                err.data.promos.length > 0
                            ) {
                                let errorCode = this.isExistErrorCode(
                                    err.data.promos,
                                );
                                if (
                                    errorCode &&
                                    errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ40
                                ) {
                                    msg = T(
                                        'shopping_cart_error_code_E1PQ40_message',
                                    );
                                } else if (
                                    errorCode &&
                                    errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ35
                                ) {
                                    msg = T(
                                        'shopping_cart_error_code_E1PQ35_message',
                                    );
                                } else {
                                    msg = err.data.promos[0].errorMessage;
                                }
                            } else {
                                msg = T('notification_order_promo_failed');
                            }

                            this.setState({
                                promoWarningFlg: true,
                                promoErrorMsg: msg,
                            });
                        }

                        this.setState({pageLoading: false});
                        this.disableOverFlow(false);
                    });
            }
        }
    };

    isExistErrorCode = (promos) => {
        let errorCode = '';
        promos.map((promoItem, promoIndex) => {
            if (
                promoItem.errorCode &&
                promoItem.errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ40
            ) {
                errorCode = promoItem.errorCode;
            } else if (
                promoItem.errorCode &&
                promoItem.errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ35
            ) {
                errorCode = promoItem.errorCode;
            }
        });
        return errorCode;
    };

    getCurrentSupplyCenterId = () => {
        const {localData} = this.props;
        let supplyCenterId = NO_SUPPLY_CENTER_ID;
        if (!this.getBatchAddShipTo()) {
            supplyCenterId = localData.scId
                ? localData.scId
                : localData.defaultScId
                ? localData.defaultScId
                : NO_SUPPLY_CENTER_ID;
        }
        return supplyCenterId;
    };

    getShippingType = (checkedSipTypes) => {
        const {localData} = this.props;
        // let typeList = [];
        let originalCartProductList = JSON.parse(
            JSON.stringify(this.state.originalCartProductList),
        );
        // console.log(originalCartProductList);
        let cartList = JSON.parse(JSON.stringify(this.state.cartProductList));
        const currentProductList = localData.skuPrices;
        let currentCheckedCartList = [];
        cartList.length > 0 &&
            cartList.forEach((currentItem, currentIndex) => {
                currentProductList.length > 0 &&
                    currentProductList.forEach((productItem, productIndex) => {
                        if (currentItem.sku === productItem.sku) {
                            currentCheckedCartList.push(currentItem);
                        }
                    });
            });

        originalCartProductList.length > 0 &&
            originalCartProductList.forEach((cartItem, cartIndex) => {
                currentCheckedCartList.length > 0 &&
                    currentCheckedCartList.forEach(
                        (currentCartItem, currentCartIndex) => {
                            if (
                                this.getCurrentSupplyCenterId() > 0 &&
                                cartItem.product.productAttr === 'sc_black' &&
                                cartItem.sku === currentCartItem.sku
                            ) {
                                if (
                                    cartItem.product.type !==
                                    currentCartItem.product.type
                                ) {
                                    let currentType = 1;
                                    if (
                                        cartItem.product.type === 1 &&
                                        currentCartItem.product.type === 2
                                    ) {
                                        currentType = 2;
                                    } else if (
                                        cartItem.product.type === 2 &&
                                        currentCartItem.product.type === 1
                                    ) {
                                        currentType = 1;
                                    }
                                    checkedSipTypes.push({
                                        cartId: cartItem.id,
                                        sku: cartItem.sku,
                                        inventory: cartItem.product.inventory,
                                        shipType: currentType,
                                    });
                                }
                            }
                        },
                    );
            });
        return checkedSipTypes;
    };

    getCheckedSipTypes = (cartIds) => {
        let currentShipTypes = [];
        if (
            localStorage.getItem('changSkuTypeList') &&
            JSON.parse(localStorage.getItem('changSkuTypeList')).length > 0
        ) {
            currentShipTypes = JSON.parse(
                localStorage.getItem('changSkuTypeList'),
            );
        }
        let checkedSipTypes = currentShipTypes.filter((obj) =>
            cartIds.some((obj1) => obj1 == obj.cartId),
        );
        return checkedSipTypes;
    };

    generateDraftOrder = (res, priceType, navigateFlg, isUseMQuote) => {
        const {localData, cartList} = this.props;

        let localDataSkuPrices = [];
        if (navigateFlg) {
            localDataSkuPrices = res.data.skuPrices;
        } else {
            if (isUseMQuote && !this.isChoosePrice()) {
                localDataSkuPrices = this.getSelectedMQuoteSkuPrices(
                    res.data.skuPrices,
                );
            } else if (isUseMQuote && this.isChoosePrice()) {
                localDataSkuPrices = this.handleMQuoteSuccessCartPrice(res);
            } else {
                localDataSkuPrices = localData.skuPrices;
            }
        }
        console.log(
            'setCartDetails===========================================================33',
            localDataSkuPrices,
        );
        this.props.setCartDetails({
            // skuPrices: navigateFlg ? res.data.skuPrices : localData.skuPrices,
            skuPrices: localDataSkuPrices,
            orderNumbers: res.data.orderNumbers,
            // 'scmOrderNumber': res.data.scmEoneNumber.salesOrderNumber,
            // 'scmJobNumber': res.data.scmEoneNumber.jobNumber,
            // 'tfsOrderNumber': res.data.tfsEoneNumber.salesOrderNumber,
            // 'tfsJobNumber': res.data.tfsEoneNumber.jobNumber,
            promoCodes: res.data.promoCodes,
            totalPrice: res.data.totalPrice,
            priceType: priceType,
        });

        if (navigateFlg) {
            localStorage.setItem('offlineOrderCredential', []);
            this.props.history.push('/purchase/orderConfirmation', {
                bacthAddSkuEmail: this.getBatchAddEmail(),
                batchAddSkuShipTo: this.getBatchAddShipTo(),
                customerEmail: util.getPurchaseCustomerEmail(),
                customerName: util.getPurchaseCustomerName(),
            });
        }
    };

    //返回true,表示包含s quote，则切换选择价格时不需要apply quote,反之
    isHaveSQuote = () => {
        let {inputdiscountCodeList} = this.state;
        let isDiscountPrice = false;
        inputdiscountCodeList &&
            inputdiscountCodeList.length > 0 &&
            inputdiscountCodeList.forEach((quoteItem) => {
                if (quoteItem.trim().substring(0, 1).toUpperCase() === 'S') {
                    isDiscountPrice = true;
                }
            });
        return isDiscountPrice;
    };

    applyCode = (switchSelectPrice) => {
        const {localData, cartList} = this.props;
        const {discountCode, sQuote, isOnlinePrice} = this.state;
        let sQuoteNum = this.state.sQuoteNum;
        let inputdiscountCodeList = this.state.inputdiscountCodeList || [];
        let cartIds = [];
        let shipToNumber = util.getShipToNumber(localData);
        let msg = '';

        if (
            (discountCode && discountCode != sQuote) ||
            inputdiscountCodeList.length > 0
        ) {
            if (
                !(
                    typeof switchSelectPrice !== 'undefined' &&
                    switchSelectPrice &&
                    switchSelectPrice === 'switchPrice'
                )
            ) {
                this.setState({
                    updateChoosePrice: '',
                });
            }
            if (inputdiscountCodeList.length > 0) {
                if (
                    discountCode &&
                    discountCode.trim() &&
                    inputdiscountCodeList.indexOf(discountCode.trim()) !== -1
                ) {
                    this.setState(
                        {
                            pageLoading: false,
                            discountCode: '',
                        },
                        () => {
                            this.props.openNotification(
                                T('notification_promotion_quote_exist'),
                                'danger',
                            );
                        },
                    );
                } else {
                    // console.log(
                    //     'discountCode=========%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%==============',
                    //     discountCode,
                    // );
                    if (!(discountCode && discountCode.trim())) {
                        if (
                            typeof switchSelectPrice !== 'undefined' &&
                            switchSelectPrice === 'switchPrice'
                        ) {
                            if (!this.isHaveSQuote()) {
                                this.goApplyQuote();
                            } else {
                                if (inputdiscountCodeList.length === 2) {
                                    this.goApplyQuote();
                                }
                            }
                        }
                    } else {
                        console.log(
                            '应用第二个quote===============discountCode',
                            discountCode,
                            '===============inputdiscountCodeList',
                            inputdiscountCodeList,
                        );
                        if (
                            inputdiscountCodeList.length === 1 &&
                            discountCode &&
                            discountCode.trim()
                        ) {
                            this.invalidCombinationMessage(
                                discountCode,
                                inputdiscountCodeList,
                            );
                        } else {
                            this.goApplyQuote();
                        }
                    }
                }
            } else {
                if (discountCode && discountCode.trim()) {
                    this.goApplyQuote();
                }
            }
        }
    };

    invalidCombinationMessage = (discountCode, inputdiscountCodeList) => {
        if (inputdiscountCodeList.length === 1) {
            if (
                inputdiscountCodeList[0].substring(0, 1).toUpperCase() === 'P'
            ) {
                if (discountCode.substring(0, 1).toUpperCase() === 'P') {
                    //P+P
                    this.setState({discountCode: ''}, () => {
                        this.props.openNotification(
                            T('notification_not_repeat_p_quote'),
                            'danger',
                        );
                    });
                } else if (discountCode.substring(0, 1).toUpperCase() === 'D') {
                    //P+D
                    this.setState({discountCode: ''}, () => {
                        this.props.openNotification(
                            T('notification_invalid_combination_quote'),
                            'danger',
                        );
                    });
                } else {
                    //P + S/R
                    this.goApplyQuote();
                }
            } else if (
                inputdiscountCodeList[0].substring(0, 1).toUpperCase() === 'D'
            ) {
                if (discountCode.substring(0, 1).toUpperCase() === 'P') {
                    //D+P
                    this.setState({discountCode: ''});
                    this.props.openNotification(
                        T('notification_invalid_combination_quote'),
                        'danger',
                    ); //D+P
                } else if (discountCode.substring(0, 1).toUpperCase() === 'D') {
                    //D+D
                    this.setState({discountCode: ''});
                    this.props.openNotification(
                        T('notification_not_repeat_d_quote'),
                        'danger',
                    );
                } else {
                    this.goApplyQuote();
                }
            } else if (
                inputdiscountCodeList[0].substring(0, 1).toUpperCase() === 'R'
            ) {
                if (discountCode.substring(0, 1).toUpperCase() === 'R') {
                    //R+R
                    this.setState({discountCode: ''});
                    this.props.openNotification(
                        T('notification_not_repeat_r_quote'),
                        'danger',
                    );
                } else if (discountCode.substring(0, 1).toUpperCase() === 'M') {
                    // M + R
                    this.setState({discountCode: ''});
                    this.props.openNotification(
                        T('notification_invalid_combination_quote'),
                        'danger',
                    );
                } else {
                    this.goApplyQuote();
                }
            } else if (
                inputdiscountCodeList[0].substring(0, 1).toUpperCase() ===
                APPLY_QUOTE_TYPE.M_QUOTE
            ) {
                if (
                    discountCode.substring(0, 1).toUpperCase() ===
                    APPLY_QUOTE_TYPE.R_QUOTE
                ) {
                    // R + M
                    this.setState({discountCode: ''});
                    this.props.openNotification(
                        T('notification_invalid_combination_quote'),
                        'danger',
                    );
                } else if (
                    discountCode.substring(0, 1).toUpperCase() ===
                    APPLY_QUOTE_TYPE.M_QUOTE
                ) {
                    // M + M
                    this.setState({discountCode: ''});
                    this.props.openNotification(
                        T('notification_not_repeat_m_quote'),
                        'danger',
                    );
                } else {
                    this.goApplyQuote();
                }
            } else {
                this.goApplyQuote();
            }
        }
    };

    goApplyQuote = () => {
        const {localData, cartList} = this.props;
        const {discountCode, sQuote, isOnlinePrice} = this.state;
        let sQuoteNum = this.state.sQuoteNum;
        let inputdiscountCodeList = this.state.inputdiscountCodeList || [];
        let cartIds = [];
        let shipToNumber = util.getShipToNumber(localData);
        let msg = '';
        // S Quote
        if (discountCode.trim().substring(0, 1).toUpperCase() === 'S') {
            window.scrollTo(0, 0);
            this.setState({
                pageLoading: true,
            });

            let currentSupplyCenterId = localData.scId
                ? localData.scId
                : localData.defaultScId;
            if (this.getBatchAddShipTo()) {
                currentSupplyCenterId = NO_SUPPLY_CENTER_ID;
            }

            this.props
                .calculateSquotePrice({
                    shipToNum: shipToNumber,
                    promoCode: discountCode.trim(),
                    supplyCenterId: currentSupplyCenterId,
                })
                .then((res) => {
                    inputdiscountCodeList.push(discountCode.trim());

                    res &&
                        res.data &&
                        res.data.orderLineDetails.forEach((item) => {
                            sQuoteNum += item.desiredQty;
                        });

                    this.setState({
                        sQuote: discountCode.trim(),
                        pageLoading: false,
                        sQuoteConfirmFlg: true,
                        sQuoteNum: sQuoteNum,
                        cartUpdate: true,
                        discountCode: '',
                    });
                })
                .catch((err) => {
                    if (err.status !== 'cmgt_error') {
                        if (err.status === 'invalid_quote') {
                            msg = T('notification_order_promo_invalid');
                        } else if (err.status === 'expired_quote') {
                            msg = T(
                                'notification_order_promo_not_active_or_expired',
                            );
                        } else if (err.status === 'mismatch_quote') {
                            msg = this.getMismatchQuoteDataMessage(err);
                        } else if (err.status === 'invalid_combination_quote') {
                            msg = T('notification_invalid_combination_quote');
                        } else if (err.status === 'Invalid_ShipTo') {
                            msg = T('notification_invalid_st_or_bt');
                        } else if (
                            !err.status &&
                            err.data &&
                            err.data.promos &&
                            err.data.promos.length > 0
                        ) {
                            let errorCode = this.isExistErrorCode(
                                err.data.promos,
                            );
                            if (
                                errorCode &&
                                errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ40
                            ) {
                                msg = T(
                                    'shopping_cart_error_code_E1PQ40_message',
                                );
                            } else if (
                                errorCode &&
                                errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ35
                            ) {
                                msg = T(
                                    'shopping_cart_error_code_E1PQ35_message',
                                );
                            } else {
                                msg = err.data.promos[0].errorMessage;
                            }
                        } else {
                            msg = T('notification_order_promo_failed');
                        }

                        this.setState({
                            pageLoading: false,
                            promoWarningFlg: true,
                            discountCode: '',
                            promoErrorMsg: msg,
                        });
                    } else {
                        this.setState({
                            pageLoading: false,
                            discountCode: '',
                        });
                    }
                });

            // P,D Quote
        } else {
            cartList &&
                cartList.forEach((item) => {
                    if (item.product.available) {
                        if (!cartIds.includes(item.id)) {
                            cartIds.push(item.id);
                        }
                    }
                });

            if (cartIds && cartIds.length > 0) {
                window.scrollTo(0, 0);

                if (discountCode && discountCode.trim()) {
                    inputdiscountCodeList.push(discountCode.trim());
                }

                if (
                    !this.isApplyMQuote() ||
                    this.isChoosePrice() ||
                    (this.isApplyMQuote() &&
                        !this.isExistSupplyCenterSku({isChangeSkuType: false})
                            .isExistSCSkuFlag)
                ) {
                    this.setState({
                        pageLoading: true,
                    });
                }

                let checkedSipTypes = this.getCheckedSipTypes(cartIds);

                let typeList = this.getShippingType(checkedSipTypes);

                let applyCodeParams = {};
                if (this.getBatchAddShipTo()) {
                    applyCodeParams = {
                        promoCodes: inputdiscountCodeList,
                        shipToNum: this.getBatchAddShipTo(),
                        cartIds: cartIds,
                        supplyCenterId: NO_SUPPLY_CENTER_ID,
                        customerEmail: this.getBatchAddEmail(),
                        shipTypes: typeList,
                        priceType: isOnlinePrice ? 2 : 1,
                    };
                } else {
                    applyCodeParams = {
                        promoCodes: inputdiscountCodeList,
                        shipToNum: shipToNumber,
                        cartIds: cartIds,
                        supplyCenterId: localData.scId
                            ? localData.scId
                            : localData.defaultScId
                            ? localData.defaultScId
                            : NO_SUPPLY_CENTER_ID,
                        customerEmail: localData.customerEmail,
                        shipTypes: typeList,
                        priceType: isOnlinePrice ? 2 : 1,
                    };
                }

                if (
                    isOnlinePrice &&
                    this.isApplyRQuote() &&
                    this.isExistOnlinePrice(cartList, isOnlinePrice)
                ) {
                    this.setState({
                        existOnlinePriceDialog: true,
                        dialogApplyCodeParams: applyCodeParams,
                        dialogInputdiscountCodeList: inputdiscountCodeList,
                    });
                } else if (
                    this.isApplyMQuote() &&
                    this.isExistSupplyCenterSku({isChangeSkuType: false})
                        .isExistSCSkuFlag
                ) {
                    this.setState({
                        changeDeliveryChannelToE1Dialog: true,
                        dialogApplyCodeParams: applyCodeParams,
                        dialogInputdiscountCodeList: inputdiscountCodeList,
                    });
                } else if (
                    this.isApplyMQuote() &&
                    this.isApplyMQuote() &&
                    this.isChoosePrice()
                ) {
                    // 切换Price 方式时，获取Ship types传递到后端
                    applyCodeParams.shipTypes =
                        this.switchChoosePriceGetShipTypes();
                    this.applyCodeCalculatePrice(
                        applyCodeParams,
                        inputdiscountCodeList,
                    );
                } else {
                    this.applyCodeCalculatePrice(
                        applyCodeParams,
                        inputdiscountCodeList,
                    );
                }
            }
        }
    };

    switchChoosePriceGetShipTypes = () => {
        let currentOriginalCartProductList = JSON.parse(
            JSON.stringify(this.state.originalCartProductList),
        );

        let scSkuList = [];
        currentOriginalCartProductList.forEach((cartItem) => {
            if (this.isMQuoteSupplyCenterCart(cartItem)) {
                scSkuList.push({
                    cartId: cartItem.id,
                    shipType: PRODUCT_TYPE.TFS_ORDER,
                    sku: cartItem.sku,
                });
            }
        });

        return scSkuList;
    };

    isApplyMQuote = () => {
        let {inputdiscountCodeList} = this.state;
        let isApplyMQuoteFlag = false;
        inputdiscountCodeList &&
            inputdiscountCodeList.length > 0 &&
            inputdiscountCodeList.forEach((codeItem) => {
                if (
                    codeItem.trim().substring(0, 1).toUpperCase() ===
                    APPLY_QUOTE_TYPE.M_QUOTE
                ) {
                    isApplyMQuoteFlag = true;
                }
            });
        return isApplyMQuoteFlag;
    };

    isApplyRQuote = () => {
        let {inputdiscountCodeList} = this.state;
        let isApplyRQuoteFlag = false;
        inputdiscountCodeList &&
            inputdiscountCodeList.length > 0 &&
            inputdiscountCodeList.forEach((codeItem) => {
                if (codeItem.trim().substring(0, 1).toUpperCase() === 'R') {
                    isApplyRQuoteFlag = true;
                }
            });
        return isApplyRQuoteFlag;
    };

    wopApplyRQuote = () => {
        const {existOnlinePriceDialog} = this.state;
        let applyCodeParams = this.state.dialogApplyCodeParams;
        let inputdiscountCodeList = this.state.dialogInputdiscountCodeList;

        if (existOnlinePriceDialog && this.isApplyRQuote()) {
            this.setState(
                {
                    existOnlinePriceDialog: false,
                    applyQuoteOperation: false,
                },
                () => {
                    this.setState({
                        pageLoading: true,
                    });
                    console.log(
                        'pageloading=========================',
                        this.state.pageLoading,
                    );
                    this.applyCodeCalculatePrice(
                        applyCodeParams,
                        inputdiscountCodeList,
                    );
                },
            );
        }
    };

    applyMQuote = () => {
        const {changeDeliveryChannelToE1Dialog} = this.state;
        let applyCodeParams = this.state.dialogApplyCodeParams;
        let inputdiscountCodeList = this.state.dialogInputdiscountCodeList;

        //确定应用Mquote 时，改变购物的sku的类型
        let isChangeSkuTypeObj = {
            isChangeSkuType: true,
        };
        applyCodeParams.shipTypes =
            this.isExistSupplyCenterSku(isChangeSkuTypeObj).scSkuList;
        if (changeDeliveryChannelToE1Dialog) {
            this.setState(
                {
                    changeDeliveryChannelToE1Dialog: false,
                    applyQuoteOperation: false,
                },
                () => {
                    this.setState({
                        pageLoading: true,
                    });

                    this.applyCodeCalculatePrice(
                        applyCodeParams,
                        inputdiscountCodeList,
                    );
                },
            );
        }
    };

    isExistOnlinePrice = (cartList, isOnlinePrice) => {
        let isExistFlag = false;
        cartList &&
            cartList.forEach((item) => {
                if (item.product.onlinePrice && isOnlinePrice) {
                    isExistFlag = true;
                }
            });
        return isExistFlag;
    };

    applyQuoteSuccessfullyMessage = (isOnlinePrice, inputdiscountCodeList) => {
        let successMessage = '';
        const {cartList} = this.props;
        if (isOnlinePrice) {
            let isIncludeR = false;
            let isIncludeM = false;
            inputdiscountCodeList &&
                inputdiscountCodeList.length > 0 &&
                inputdiscountCodeList.forEach((quoteItem) => {
                    if (
                        quoteItem.trim().substring(0, 1).toUpperCase() === 'R'
                    ) {
                        isIncludeR = true;
                    } else if (
                        quoteItem.trim().substring(0, 1).toUpperCase() ===
                        APPLY_QUOTE_TYPE.M_QUOTE
                    ) {
                        isIncludeM = true;
                    }
                });

            let hasWebOnlyPrice = this.checkWebOnlyPrice(cartList);
            if (hasWebOnlyPrice) {
                if (isIncludeR || isIncludeM) {
                    successMessage =
                        'notification_promotion_code_applied_successfully';
                } else {
                    successMessage =
                        'notification_promotion_code_final_price_is_best';
                }
            } else {
                successMessage =
                    'notification_promotion_code_applied_successfully';
            }
        } else {
            successMessage = 'notification_promotion_code_applied_successfully';
        }
        this.props.openNotification(T(successMessage), 'danger');
    };

    isExistSupplyCenterSku = (isChangeSkuTypeObj) => {
        let currentCartProductList = JSON.parse(
            JSON.stringify(this.state.cartProductList),
        );
        let supplyCenterSkuObj = {
            isExistSCSkuFlag: false, //应用M quote时，是否存在sc 的sku,true表示存在sc 的sku，反之则不存在
            scSkuList: [], //收集sc 的sku，并将其shipType改为官网类型
        };
        let skuList = [];
        currentCartProductList.forEach((cartItem) => {
            if (this.isMQuoteSupplyCenterCart(cartItem)) {
                if (isChangeSkuTypeObj.isChangeSkuType) {
                    cartItem.product.type = PRODUCT_TYPE.TFS_ORDER;
                    supplyCenterSkuObj.scSkuList.push({
                        cartId: cartItem.id,
                        shipType: PRODUCT_TYPE.TFS_ORDER,
                        sku: cartItem.sku,
                    });
                    skuList.push(cartItem.sku);
                }
                supplyCenterSkuObj.isExistSCSkuFlag = true;
            }
        });
        if (isChangeSkuTypeObj.isChangeSkuType && skuList.length > 0) {
            let tfsInventoryList = [];

            //查询要被改成官网发货的sku的官网库存，并显示官网产品的官网库存
            this.props.queryEoneInventory({skuList: skuList}).then((res) => {
                if (res && res.data) {
                    tfsInventoryList = res.data;
                    currentCartProductList.length > 0 &&
                        currentCartProductList.map(
                            (cartSkuItem, cartSkuIndex) => {
                                tfsInventoryList.length > 0 &&
                                    tfsInventoryList.map(
                                        (tfsSkuItem, tfsSkuIndex) => {
                                            if (
                                                cartSkuItem.sku ===
                                                tfsSkuItem.sku
                                            ) {
                                                cartSkuItem.product.availableInventory =
                                                    parseInt(
                                                        tfsSkuItem.availableInventory,
                                                    );
                                            }
                                        },
                                    );
                            },
                        );
                }
            });
        }

        this.setState({
            cartProductList: currentCartProductList,
        });

        return supplyCenterSkuObj;
    };

    getSelectedMQuoteSkuPrices = (skuPrices, includeFreeGoods = true) => {
        const {localData} = this.props;
        const selectedPrimarySkuPrices = (localData.skuPrices || []).filter(
            (item) => !item.freeGoodItem,
        );
        const selectedCartIds = selectedPrimarySkuPrices.map(
            (item) => item.cartId,
        );
        const priceByCartId = (skuPrices || [])
            .filter((item) => !item.freeGoodItem)
            .reduce((prices, item) => {
                prices[item.cartId] = item;
                return prices;
            }, {});

        const primarySkuPrices = selectedPrimarySkuPrices.map((item) => {
            const price = priceByCartId[item.cartId];
            return price ? {...item, ...this.getSkuPriceObj(price)} : item;
        });
        const freeGoodSkuPrices = includeFreeGoods
            ? (skuPrices || [])
                  .filter(
                      (item) =>
                          item.freeGoodItem &&
                          selectedCartIds.includes(item.cartId),
                  )
                  .map((item) => this.getSkuPriceObj(item))
            : [];

        return [...primarySkuPrices, ...freeGoodSkuPrices];
    };

    getSelectedMQuoteQuantity = (skuPrices) => {
        return skuPrices.reduce(
            (totalQuantity, item) => totalQuantity + item.quantity,
            0,
        );
    };

    addMQuoteFreeGood = (res) => {
        let currentCartProductList = JSON.parse(
            JSON.stringify(this.state.cartProductList),
        );
        let haveFreeGoodCartProductList = [];

        if (res.status === 'success' && res.data) {
            let isOnlyFreeGoodCartList = res.data.skuPrices.filter(
                (item, freeGoodIndex) => {
                    item.indexNumber = freeGoodIndex;
                    return item.freeGoodItem;
                },
            );

            isOnlyFreeGoodCartList.map((skuPriceItem) => {
                let tempCartProduct = Object.assign({}, skuPriceItem);
                tempCartProduct = {
                    sku: skuPriceItem.sku,
                    quantity: skuPriceItem.quantity,
                    indexNumber: skuPriceItem.indexNumber,
                    cartId: skuPriceItem.cartId,
                    product: {
                        available: true,
                        productName: skuPriceItem.promoFreeGoodItem.productName,
                        productPic: skuPriceItem.promoFreeGoodItem.productPic,
                        specifications:
                            skuPriceItem.promoFreeGoodItem.specifications,
                        efPrice: skuPriceItem.efPrice,
                        finalPrice: skuPriceItem.finalPrice,
                        listPrice: skuPriceItem.listPrice,
                        onlinePrice: skuPriceItem.onlinePrice,
                        freeGoodItem: skuPriceItem.freeGoodItem,
                        type: PRODUCT_TYPE.TFS_ORDER,
                        sku: skuPriceItem.sku,
                    },
                };
                haveFreeGoodCartProductList.push(tempCartProduct);
            });
        }

        let tempCartProductList = currentCartProductList.filter(
            (tempItem, tempIndex) => {
                return !tempItem.product.freeGoodItem;
            },
        );

        haveFreeGoodCartProductList.length > 0 &&
            haveFreeGoodCartProductList.map((freedGood) => {
                tempCartProductList.splice(freedGood.indexNumber, 0, freedGood);
            });

        let selectedSkuPrices = this.getSelectedMQuoteSkuPrices(
            res.data && res.data.skuPrices,
        );
        this.setState({
            cartProductList: tempCartProductList,
            checkNum: this.getSelectedMQuoteQuantity(selectedSkuPrices),
        });
    };

    applyCodeCalculatePrice = (applyCodeParams, inputdiscountCodeList) => {
        const {isOnlinePrice, updateChoosePrice} = this.state;
        let msg = '';
        let isUseMQuote = this.isApplyMQuote();

        if (this.isApplyMQuote()) {
            applyCodeParams.shipTypes = this.switchChoosePriceGetShipTypes();
        }

        this.props
            .calculatePrice(applyCodeParams, false, updateChoosePrice)
            .then((res) => {
                this.setState(
                    {
                        applyQuoteOperation: true,
                    },
                    () => {
                        let priceParam = {
                            res: res,
                            isApplyMQuoteFlay: isUseMQuote,
                        };
                        this.refreshPrice(priceParam);
                        this.getCurrentApplyPrice(res.data.skuPrices);
                        this.generateDraftOrder(
                            res,
                            isOnlinePrice ? 2 : 1,
                            false,
                            isUseMQuote,
                        );
                        this.setState({
                            pageLoading: false,
                            inputdiscountCodeList: inputdiscountCodeList,
                            cartUpdate: false,
                            dialogApplyCodeParams: '',
                            dialogInputdiscountCodeList: [],
                        });
                        this.applyQuoteSuccessfullyMessage(
                            isOnlinePrice,
                            inputdiscountCodeList,
                        );

                        if (isUseMQuote) {
                            this.addMQuoteFreeGood(res);
                        }
                    },
                );
            })
            .catch((err) => {
                inputdiscountCodeList.pop();
                console.log(
                    'inputdiscountCodeList============================================================',
                    inputdiscountCodeList,
                );
                console.log(
                    'calculatePrice============================================================err',
                    err.data,
                    err.data.promoCodes,
                );

                if (isUseMQuote) {
                    this.applyMQuoteFailedChangeSkuType();
                }
                this.setState({
                    dialogApplyCodeParams: '',
                    dialogInputdiscountCodeList: [],
                });
                if (this.isChoosePrice()) {
                    if (err.status !== 'cmgt_error') {
                        this.getCurrentApplyPrice(err.data.skuPrices);
                        this.chooseFailureUpdateLocalDataSkuPrices(
                            err.data.skuPrices,
                        );
                        console.log(
                            '切换选择价格时，应用R quote失败===============================this.props.localData.skuPrices',
                            this.props.localData.skuPrices,
                        );
                    }
                    this.setState({
                        inputdiscountCodeList: err.data.promoCodes,
                    });
                }

                this.props.setCartOrderNumber({
                    orderNumbers: [],
                });
                if (err.status !== 'cmgt_error') {
                    if (err.status === 'oem_product_promo_not_supported') {
                        msg = T('oem_product_promo_not_supported');
                    } else if (
                        err.status === 'error_promo_code' ||
                        err.status === 'error_price'
                    ) {
                        msg = T('shopping_cart_apply_failure');
                    } else if (err.status === 'invalid_quote') {
                        msg = T('notification_order_promo_invalid');
                    } else if (err.status === 'expired_quote') {
                        msg = T(
                            'notification_order_promo_not_active_or_expired',
                        );
                    } else if (err.status === 'mismatch_quote') {
                        msg = this.getMismatchQuoteDataMessage(err);
                    } else if (err.status === 'invalid_combination_quote') {
                        msg = T('notification_invalid_combination_quote');
                    } else if (err.status === 'Invalid_ShipTo') {
                        msg = T('notification_invalid_st_or_bt');
                    } else if (
                        !err.status &&
                        err.data &&
                        err.data.promos &&
                        err.data.promos.length > 0
                    ) {
                        let errorCode = this.isExistErrorCode(err.data.promos);
                        if (
                            errorCode &&
                            errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ40
                        ) {
                            msg = T('shopping_cart_error_code_E1PQ40_message');
                        } else if (
                            errorCode &&
                            errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ35
                        ) {
                            msg = T('shopping_cart_error_code_E1PQ35_message');
                        } else {
                            msg = err.data.promos[0].errorMessage;
                        }
                    } else {
                        msg = T('notification_order_promo_failed');
                    }

                    this.setState({
                        pageLoading: false,
                        discountCode: '',
                        promoWarningFlg: true,
                        promoErrorMsg: msg,
                    });
                } else {
                    this.setState({
                        pageLoading: false,
                        discountCode: '',
                    });
                }
            });
    };

    getMismatchQuoteDataMessage = (err) => {
        let msg = '';
        if (err.data && err.data.promos && err.data.promos.length > 0) {
            let errorCode = this.isExistErrorCode(err.data.promos);
            if (errorCode && errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ35) {
                msg = T('shopping_cart_error_code_E1PQ35_message');
            } else {
                msg = T('notification_order_promo_mismatch');
            }
        } else {
            msg = T('notification_order_promo_mismatch');
        }
        return msg;
    };

    //M quote应用失败时，把sku改为TFS发货的还原成SC产品
    applyMQuoteFailedChangeSkuType = () => {
        const {originalCartProductList} = this.state;
        let currentCartProductList = JSON.parse(
            JSON.stringify(this.state.cartProductList),
        );
        localStorage.setItem('changSkuTypeList', []);
        currentCartProductList.length > 0 &&
            currentCartProductList.map((cartProduct, cartProductIndex) => {
                originalCartProductList.length > 0 &&
                    originalCartProductList.map(
                        (originalCartProduct, originalCartProductIndex) => {
                            if (cartProduct.sku === originalCartProduct.sku) {
                                cartProduct.product.type =
                                    originalCartProduct.product.type;
                            }
                        },
                    );
            });

        this.setState({
            cartProductList: currentCartProductList,
        });
    };

    clearMQuoteChangeSkuType = (res) => {
        const {originalCartProductList} = this.state;
        let currentCartProductList = JSON.parse(
            JSON.stringify(this.state.cartProductList),
        );

        let notFreeGoodCartProductList = [];
        //清除Mquote时，过滤掉赠送删除
        if (currentCartProductList.length > 0) {
            currentCartProductList.map((cartItem) => {
                if (!cartItem.product.freeGoodItem) {
                    notFreeGoodCartProductList.push(cartItem);
                }
            });
        }

        notFreeGoodCartProductList.length > 0 &&
            notFreeGoodCartProductList.map((cartProduct, cartProductIndex) => {
                originalCartProductList.length > 0 &&
                    originalCartProductList.map(
                        (originalCartProduct, originalCartProductIndex) => {
                            if (cartProduct.sku === originalCartProduct.sku) {
                                cartProduct.product.type =
                                    originalCartProduct.product.type;
                            }
                        },
                    );
            });

        this.setState({
            cartProductList: notFreeGoodCartProductList,
        });
    };

    chooseFailureUpdateLocalDataSkuPrices = (skuPrices) => {
        const {cartPrice, localData} = this.props;
        const {isOnlinePrice} = this.state;
        console.log(
            skuPrices,
            '======================================',
            cartPrice,
        );
        let selectedProductArray = localData.skuPrices || [];
        if (selectedProductArray) {
            selectedProductArray.forEach((skuPriceItem) => {
                if (
                    cartPrice.status !== 'cmgt_error' &&
                    cartPrice.status !== 'success' &&
                    cartPrice.data &&
                    cartPrice.data.promoCodes.length <= 0
                ) {
                    skuPrices.length > 0 &&
                        skuPrices.forEach((cartPriceItem) => {
                            if (
                                cartPriceItem.cartId &&
                                skuPriceItem.cartId === cartPriceItem.cartId
                            ) {
                                skuPriceItem.listPrice =
                                    cartPriceItem.listPrice;
                                skuPriceItem.finalPrice = isOnlinePrice
                                    ? cartPriceItem.onlinePrice ||
                                      cartPriceItem.finalPrice
                                    : cartPriceItem.efPrice ||
                                      cartPriceItem.finalPrice;
                                skuPriceItem.noPromoPrice =
                                    skuPriceItem.finalPrice;
                            }
                        });
                }
            });
        }
        console.log(
            'setCartDetails===========================================================44',
        );
        this.props.setCartDetails({
            skuPrices: selectedProductArray,
        });
    };

    getCurrentApplyPrice = (skuPrices) => {
        let cartProductListCopy = JSON.parse(
            JSON.stringify(this.state.cartProductList),
        );
        skuPrices.length > 0 &&
            skuPrices.forEach((skuItem) => {
                cartProductListCopy.length > 0 &&
                    cartProductListCopy.forEach((cartItem) => {
                        if (skuItem.cartId && skuItem.cartId === cartItem.id) {
                            cartItem.product.efPrice = skuItem.efPrice;
                            cartItem.product.finalPrice = skuItem.finalPrice;
                            cartItem.product.listPrice = skuItem.listPrice;
                            cartItem.product.onlinePrice = skuItem.onlinePrice;
                        }
                    });
            });
        this.setState({
            cartProductList: cartProductListCopy,
        });
    };

    clearCode = (code) => {
        const {localData, cartList} = this.props;
        const {inputdiscountCodeList, sQuote, isOnlinePrice} = this.state;
        let codeList = [];
        let cartIds = [];
        let shipToNumber = util.getShipToNumber(localData);
        let msg = '';
        let isUseMQuote = this.isApplyMQuote();

        if (cartList.length <= 0 && !sQuote) {
            this.setState({
                inputdiscountCodeList: [],
            });
            return;
        }

        cartList &&
            cartList.forEach((item) => {
                if (item.product.available) {
                    cartIds.push(item.id);
                }
            });

        codeList =
            inputdiscountCodeList &&
            inputdiscountCodeList.filter((item) => {
                return item !== code;
            });

        // P,D Quote
        if (code.trim().substring(0, 1).toUpperCase() !== 'S') {
            let checkedSipTypes = this.getCheckedSipTypes(cartIds);
            let typeList = this.getShippingType(checkedSipTypes);
            let currentParams = {};

            this.setState({
                pageLoading: true,
            });

            if (this.getBatchAddShipTo()) {
                currentParams = {
                    promoCodes: codeList,
                    shipToNum: this.getBatchAddShipTo(),
                    cartIds: cartIds,
                    supplyCenterId: NO_SUPPLY_CENTER_ID,
                    customerEmail: this.getBatchAddEmail(),
                    shipTypes: typeList,
                    priceType: isOnlinePrice ? 2 : 1,
                };
            } else {
                currentParams = {
                    promoCodes: codeList,
                    shipToNum: shipToNumber,
                    cartIds: cartIds,
                    supplyCenterId: localData.scId
                        ? localData.scId
                        : localData.defaultScId
                        ? localData.defaultScId
                        : NO_SUPPLY_CENTER_ID,
                    customerEmail: localData.customerEmail,
                    shipTypes: typeList,
                    priceType: isOnlinePrice ? 2 : 1,
                };
            }
            if (
                this.isApplyMQuote() &&
                code.trim().substring(0, 1).toUpperCase() !==
                    APPLY_QUOTE_TYPE.M_QUOTE
            ) {
                currentParams.shipTypes = this.switchChoosePriceGetShipTypes();
            }
            this.props
                .calculatePrice(currentParams)
                .then((res) => {
                    let priceParam = {
                        res: res,
                        isApplyMQuoteFlay: isUseMQuote,
                        isClearFlag: true,
                    };
                    this.refreshPrice(priceParam);
                    this.getCurrentApplyPrice(res.data.skuPrices); //清除quote，用最新的skuPrices
                    console.log(
                        'cartProductList==========================================444',
                        res.data,
                    );

                    // if (this.onlySQuoteSuccess()) {
                    //     this.updateLocalSkuPrices();
                    // }

                    if (
                        isUseMQuote &&
                        code.trim().substring(0, 1).toUpperCase() ===
                            APPLY_QUOTE_TYPE.M_QUOTE
                    ) {
                        this.clearMQuoteChangeSkuType(res);
                        this.props.setCartOrderNumber({
                            orderNumbers: [],
                        });
                    }

                    this.setState({
                        pageLoading: false,
                        inputdiscountCodeList: codeList,
                        cartUpdate: false,
                    });
                })
                .catch((err) => {
                    this.props.setCartOrderNumber({
                        orderNumbers: [],
                    });
                    if (isUseMQuote) {
                        this.applyMQuoteFailedChangeSkuType();
                    }
                    if (err.status !== 'cmgt_error') {
                        if (
                            err.status === 'error_promo_code' ||
                            err.status === 'error_price'
                        ) {
                            msg = T('shopping_cart_apply_failure');
                        } else if (err.status === 'invalid_quote') {
                            msg = T('notification_order_promo_invalid');
                        } else if (err.status === 'expired_quote') {
                            msg = T(
                                'notification_order_promo_not_active_or_expired',
                            );
                        } else if (err.status === 'mismatch_quote') {
                            msg = this.getMismatchQuoteDataMessage(err);
                        } else if (err.status === 'Invalid_ShipTo') {
                            msg = T('notification_invalid_st_or_bt');
                        } else if (err.status !== 'cmgt_error') {
                            msg = T('notification_order_promo_failed');
                        } else if (err.status === 'invalid_combination_quote') {
                            msg = T('notification_invalid_combination_quote');
                        } else if (
                            !err.status &&
                            err.data &&
                            err.data.promos &&
                            err.data.promos.length > 0
                        ) {
                            let errorCode = this.isExistErrorCode(
                                err.data.promos,
                            );
                            if (
                                errorCode &&
                                errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ40
                            ) {
                                msg = T(
                                    'shopping_cart_error_code_E1PQ40_message',
                                );
                            } else if (
                                errorCode &&
                                errorCode === APPLY_QUOTE_ERROR_CODE.E1PQ35
                            ) {
                                msg = T(
                                    'shopping_cart_error_code_E1PQ35_message',
                                );
                            } else {
                                msg = err.data.promos[0].errorMessage;
                            }
                        } else {
                            msg = T('notification_order_promo_failed');
                        }

                        this.setState({
                            pageLoading: false,
                            inputdiscountCodeList: err.data.promoCodes,
                            promoWarningFlg: true,
                            promoErrorMsg: msg,
                        });
                    } else {
                        this.setState({
                            pageLoading: false,
                            inputdiscountCodeList: err.data.promoCodes,
                        });
                    }
                });

            // S Quote
        } else {
            this.removeSItems();
        }
    };

    updateLocalSkuPrices = () => {
        const {localData, cartPrice} = this.props;
        const {isOnlinePrice} = this.state;
        let selectedProductArray = localData.skuPrices || [];

        if (selectedProductArray.length > 0) {
            selectedProductArray.forEach((skuPriceItem) => {
                if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
                    cartPrice.data.skuPrices.forEach((cartPriceItem) => {
                        if (
                            cartPriceItem.cartId &&
                            skuPriceItem.cartId === cartPriceItem.cartId
                        ) {
                            skuPriceItem.listPrice = cartPriceItem.listPrice;
                            skuPriceItem.finalPrice = isOnlinePrice
                                ? cartPriceItem.onlinePrice ||
                                  cartPriceItem.finalPrice
                                : cartPriceItem.efPrice ||
                                  cartPriceItem.finalPrice;
                            skuPriceItem.noPromoPrice = skuPriceItem.finalPrice;
                        }
                    });
                }
            });
        }

        console.log(
            'setCartDetails===========================================================55',
        );
        this.props.setCartDetails({
            skuPrices: selectedProductArray,
        });
    };

    removeSItems = () => {
        this.setState({
            sQuoteClearFlg: true,
        });
    };

    getSkuPriceObj = (item, isClearFlag) => {
        let tempPriceObj = {
            finalPrice: isClearFlag ? item.finalPrice : item.finalPrice,
            cartId: item.cartId,
            listPrice: item.listPrice,
            freeGoodItem: item.freeGoodItem,
            sku: item.sku,
            productName:
                item.promoFreeGoodItem && item.promoFreeGoodItem.productName,
            noPromoPrice: item.finalPrice,
            quantity: item.quantity,
        };
        return tempPriceObj;
    };

    refreshPrice = (priceParam) => {
        let productDetails = [];

        if (
            typeof priceParam.isApplyMQuoteFlay !== 'undefined' &&
            priceParam.isApplyMQuoteFlay &&
            priceParam.res.data.skuPrices.length > 0 &&
            typeof priceParam.isClearFlag === 'undefined'
        ) {
            this.mQuoteChangeSelectProductDetails(
                priceParam.res.data.skuPrices,
            );
        } else if (
            typeof priceParam.isApplyMQuoteFlay !== 'undefined' &&
            priceParam.isApplyMQuoteFlay &&
            typeof priceParam.isClearFlag !== 'undefined' &&
            priceParam.isClearFlag
        ) {
            console.log(priceParam.res.data.skuPrices);
            const tempSkuPrices = this.getSelectedMQuoteSkuPrices(
                priceParam.res.data.skuPrices,
                false,
            );
            this.setState({
                checkNum: this.getSelectedMQuoteQuantity(tempSkuPrices),
            });
            this.props.setCartDetails({
                skuPrices: tempSkuPrices,
            });
        } else {
            productDetails =
                priceParam.res.data &&
                priceParam.res.data.skuPrices.map((item) => {
                    return {
                        finalPrice: item.finalPrice,
                        cartId: item.cartId,
                        listPrice: item.listPrice,
                    };
                });
            this.changeSelectProductDetails(productDetails);
        }

        this.setState({
            inputdiscountCodeList: priceParam.res.data.promoCodes,
            discountCode: '',
        });
    };

    mQuoteChangeSelectProductDetails = (productList) => {
        if (this.isApplyMQuote() && this.isChoosePrice()) {
            this.props.setCartDetails({
                skuPrices: productList.map((item) => this.getSkuPriceObj(item)),
            });
        } else {
            const selectedSkuPrices =
                this.getSelectedMQuoteSkuPrices(productList);
            this.props.setCartDetails({
                skuPrices: selectedSkuPrices,
            });
            this.setState({
                checkNum: this.getSelectedMQuoteQuantity(selectedSkuPrices),
            });
        }
    };

    getClearQuoteSuccessSkuInfo = (cartId) => {
        const {cartPrice} = this.props;
        let currentSkuInfor = {};
        if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
            cartPrice.data.skuPrices.forEach((skuItem) => {
                if (cartId === skuItem.cartId) {
                    currentSkuInfor = skuItem;
                }
            });
        }
        return currentSkuInfor;
    };

    changeSelectProductDetails = (productList, checkFlg) => {
        const {localData, cartPrice} = this.props;

        let selectedProductArray = localData.skuPrices || [];

        console.log(
            'selectedProductArray====================1111111',
            selectedProductArray,
        );

        if (!checkFlg) {
            if (selectedProductArray && selectedProductArray.length > 0) {
                productList &&
                    productList.forEach((itemA) => {
                        selectedProductArray =
                            localData.skuPrices &&
                            localData.skuPrices.map((itemB) => {
                                if (itemA.cartId === itemB.cartId) {
                                    itemB.quantity = itemA.quantity
                                        ? itemA.quantity
                                        : itemB.quantity;
                                    itemB.finalPrice = itemA.finalPrice
                                        ? itemA.finalPrice
                                        : itemB.finalPrice;
                                    if (
                                        cartPrice.data &&
                                        cartPrice.data.skuPrices.length > 0 &&
                                        cartPrice.data.promoCodes.length > 0
                                    ) {
                                        itemB.noPromoPrice = itemA.finalPrice
                                            ? itemA.finalPrice
                                            : itemB.finalPrice;
                                    } else if (this.clearCodeSuccess()) {
                                        console.log(
                                            'selectedProductArray====================666666',
                                            selectedProductArray,
                                            cartPrice.data.skuPrices,
                                        );
                                        let currentSkuInfor =
                                            this.getClearQuoteSuccessSkuInfo(
                                                itemB.cartId,
                                            );
                                        if (
                                            JSON.stringify(currentSkuInfor) !==
                                            '{}'
                                        ) {
                                            itemB.quantity =
                                                currentSkuInfor.quantity
                                                    ? currentSkuInfor.quantity
                                                    : itemB.quantity;
                                            itemB.finalPrice =
                                                currentSkuInfor.efPrice ||
                                                currentSkuInfor.finalPrice;
                                            itemB.noPromoPrice =
                                                currentSkuInfor.onlinePrice ||
                                                currentSkuInfor.finalPrice;
                                        }
                                    }
                                } else if (itemA.id === itemB.cartId) {
                                    itemB.quantity = itemA.quantity
                                        ? itemA.quantity
                                        : itemB.quantity;
                                    itemB.finalPrice =
                                        itemA.product.efPrice ||
                                        itemA.product.finalPrice;
                                    itemB.noPromoPrice =
                                        itemA.product.onlinePrice ||
                                        itemA.product.finalPrice;
                                }
                                return itemB;
                            });
                    });

                if (this.isInitCartData() || this.clearCodeSuccess()) {
                    this.props.calculatePrice({}, true);
                }
                console.log(
                    'changeSelectProductDetails====================2222222',
                    selectedProductArray,
                );
            }
        } else {
            if (cartPrice.data && cartPrice.data.skuPrices.length > 0) {
                cartPrice.data &&
                    cartPrice.data.skuPrices.forEach((itemA) => {
                        selectedProductArray =
                            productList &&
                            productList.map((itemB) => {
                                if (itemA.cartId === itemB.cartId) {
                                    itemB.finalPrice = itemA.finalPrice
                                        ? itemA.finalPrice
                                        : itemB.finalPrice;
                                }
                                return itemB;
                            });
                    });
            } else {
                selectedProductArray = productList;
            }
        }

        console.log(
            'setCartDetails===========================================================77',
        );
        this.props.setCartDetails({
            skuPrices: selectedProductArray,
        });
    };

    backButtonAction = () => {
        localStorage.setItem('changSkuTypeList', []);
        this.props.updateFromShoppingCart(true);
        if (this.props.match.url.indexOf('test') !== -1) {
            this.props.history.push('/productList', {fromShoppingCart: true});
        } else {
            this.props.history.goBack();
        }
    };

    updatePrice = (cartItem, cartPrice) => {
        let cartPriceItem = '';

        if (cartPrice.data) {
            cartPriceItem = cartPrice.data.skuPrices.filter((item) => {
                return item.cartId === cartItem.id;
            });
        }

        return cartPriceItem[0] || '';
    };

    disableOverFlow = (flg) => {
        let body = document.getElementsByTagName('body')[0];

        if (flg) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = 'visible';
        }
    };

    checkWebOnlyPrice = (cartList) => {
        let flg = false;

        cartList &&
            cartList.forEach((item, key) => {
                if (item.product.onlinePrice) {
                    flg = true;
                }
            });

        return flg;
    };

    getDeleteNum = () => {
        const {disabledSelected, checkNum} = this.state;
        let num = checkNum;

        if (disabledSelected && disabledSelected.length !== 0) {
            disabledSelected.forEach(function (item) {
                num = num + item.quantity;
            });
        }

        return num;
    };

    openDialog = (key) => !this.setState[key] && this.setState({[key]: true});
    dialogDidClose = (key) => {
        this.state[key] && this.setState({[key]: false});
        if (key === 'isOpenchangeShipDialog') {
            localStorage.setItem(
                'changSkuTypeList',
                JSON.stringify(this.state.changeSkuList),
            );
            if (
                localStorage.getItem('changSkuTypeList') &&
                JSON.parse(localStorage.getItem('changSkuTypeList')).length > 0
            ) {
                this.setState({
                    cartUpdate: true,
                });
            }
            let currentCartProductList = JSON.parse(
                JSON.stringify(this.state.cartProductList),
            );

            this.state.changeSkuList.length > 0 &&
                this.state.changeSkuList.map((itemType, indexType) => {
                    currentCartProductList.map((item, index) => {
                        if (itemType.sku === item.product.sku) {
                            item.product.type = itemType.shipType; //改为官网类型
                            item.product.availableInventory =
                                itemType.inventory;
                        }
                    });
                });

            // if (this.state.changeSkuList.length > 0) {
            //     this.setState({
            //         cartProductList: currentCartProductList,
            //     });
            // }
            console.log(
                'cartProductList==========================================555',
                currentCartProductList,
            );
            this.setState({
                cartProductList: currentCartProductList,
            });
        } else if (key === 'existOnlinePriceDialog') {
            let inputdiscountCodeList = this.state.inputdiscountCodeList;
            let discountCode = this.state.discountCode;
            if (discountCode && discountCode.trim()) {
                inputdiscountCodeList = inputdiscountCodeList.filter(
                    (discountItem, index) => {
                        return discountItem !== discountCode;
                    },
                );
            }
            this.setState({
                // discountCode: '',
                inputdiscountCodeList: inputdiscountCodeList,
                pageLoading: false,
            });
        } else if (key === 'changeDeliveryChannelToE1Dialog') {
            let inputdiscountCodeList = this.state.inputdiscountCodeList;
            let discountCode = this.state.discountCode;
            if (discountCode && discountCode.trim()) {
                inputdiscountCodeList = inputdiscountCodeList.filter(
                    (discountItem, index) => {
                        return discountItem !== discountCode;
                    },
                );
            }
            this.setState({
                inputdiscountCodeList: inputdiscountCodeList,
                pageLoading: false,
            });
        }
    };

    sQuoteDialogClose = (key) => {
        this.state[key] && this.setState({[key]: false});

        this.clearSquote();
    };

    getQuote = (param) => {
        if (!param || param.length < 1) return;
        let batchParam = {
            customerEmail: this.getBatchAddEmail(),
            scId: -1,
        };
        if (this.getBatchAddShipTo()) {
            this.props.getCustomerQuote(param, false, null);
        } else {
            this.props.getCustomerQuote(param, false, null);
        }
    };

    getRecommendQuote = (param) => {
        let batchRecommendParam = {
            customerEmail: this.getBatchAddEmail(),
            scId: -1,
        };
        if (this.getBatchAddShipTo()) {
            this.props.getCustomerQuote(
                param,
                batchRecommendParam,
                this.quoteCallback,
            );
        } else {
            this.props.getCustomerQuote(
                param,
                this.props.localData,
                this.quoteCallback,
            );
        }
        this.props.operationLog({
            opTarget: 'view_sku_promo_cart',
            opContent: param,
            opReqUrl: 'api/quote/sku',
        });
    };

    quoteCallback = (res) => {
        if (res.status === 'success' && res.data.length !== 0) {
            this.setState({
                isQuoteInfor: true,
            });
        } else if (res.status === 'success' && res.data.length === 0) {
            this.props.openNotification(
                T('notification_quote_null'),
                'success',
            );
        } else {
            this.props.openNotification(
                T('notification_get_quote_failed'),
                'success',
            );
        }
    };

    closeQuoteDetails = () => {
        this.setState({
            isQuoteInfor: false,
        });
    };

    copyContent = (text) => {
        copy(text);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    // Add Shopping Cart Button event Handling
    addShoppingCart = (productInfo, num, event) => {
        const {localData} = this.props;
        this.props.operationLog({
            opTarget: 'cart_page_recommend',
            opContent: productInfo.sku,
            opReqUrl: '/api/cart/add',
        });

        this.props
            .addCart({
                productId: productInfo.id,
                customerEmail: this.getBatchAddEmail()
                    ? this.getBatchAddEmail()
                    : localData.customerEmail,
                quantity: num,
                sku: productInfo.sku,
            })
            .then(() => {
                this.queryCart({
                    isAddRecommendedFlag: true,
                    num: num,
                    productId: productInfo.id,
                });
            });
        this.setState({cartUpdate: true});
    };

    viewSkuDetailCartOperation = (sku) => {
        this.props.operationLog({
            opTarget: 'view_sku_detail_cart',
            opContent: sku,
        });
    };

    clearSquote = () => {
        const {inputdiscountCodeList, sQuote} = this.state;
        const {sPrice} = this.props;
        let sQuoteNum = this.state.sQuoteNum;
        let codeList;

        codeList =
            inputdiscountCodeList &&
            inputdiscountCodeList.filter((item) => {
                return item !== sQuote;
            });

        sPrice &&
            sPrice.orderLineDetails.forEach((item) => {
                sQuoteNum -= item.desiredQty;
            });

        this.props.calculateSquotePrice({}, true);

        this.setState({
            sQuote: '',
            inputdiscountCodeList: codeList,
            sQuoteNum: sQuoteNum,
            cartUpdate: true,
        });
    };

    // Focus on promo input
    promoFocus = () => {
        if (document.querySelector('.promo-input input')) {
            document.querySelector('.promo-input input').focus();
        }
    };

    // Judge If check all
    isCheckAll = () => {
        const {localData, cartList} = this.props;
        let selectedProductArray = localData.skuPrices || [];
        let cartIds = [];

        cartList &&
            cartList.forEach((item) => {
                if (item.product.available) {
                    cartIds.push(item.id);
                }
            });

        if (selectedProductArray.length === cartIds.length) {
            return true;
        } else {
            return false;
        }
    };

    changeShipEvent = (params) => {
        const {localData} = this.props;
        let shipToNumber = util.getShipToNumber(localData);

        if (
            !(
                localStorage.getItem('changSkuTypeList') &&
                JSON.parse(localStorage.getItem('changSkuTypeList'))
            )
        ) {
            let currentCartProductList = JSON.parse(
                JSON.stringify(this.state.cartProductList),
            );
            // this.setState({
            //     originalCartProductList: currentCartProductList,
            // });
        }

        if (this.isApplyMQuote()) {
            this.setState({
                isOpenchangeShipDialog: false,
                changeShipmentList: [],
            });
            this.props.openNotification(
                T('shopping_cart_currently_no_match_condition_sku'),
                'danger',
            );
        } else {
            this.setState({
                changeShipmentListLoading: true,
            });
            this.props
                .queryChangeShip(
                    {
                        customerEmail:
                            params && params.cusomerEmail
                                ? params.cusomerEmail
                                : localData.customerEmail,
                        supplyCenterId:
                            params && params.scId
                                ? params.scId
                                : localData.scId
                                ? localData.scId
                                : localData.defaultScId,
                        shipToNumber:
                            params && params.shipToNum
                                ? params.shipToNum
                                : shipToNumber,
                        purchaseOrderMode: util.getPurchaseOrderMode(),
                    },
                    this.updateShipmentSkuList,
                )
                .then((res) => {
                    if (res) {
                        if (res.data.length > 0) {
                            if (
                                localStorage.getItem('changSkuTypeList') &&
                                JSON.parse(
                                    localStorage.getItem('changSkuTypeList'),
                                ).length > 0
                            ) {
                                let currentchangSkuTypeList = JSON.parse(
                                    localStorage.getItem('changSkuTypeList'),
                                );

                                currentchangSkuTypeList.map(
                                    (itemType, indexType) => {
                                        res.data.map((item, index) => {
                                            if (
                                                itemType.sku ===
                                                item.product.sku
                                            ) {
                                                item.product.type =
                                                    itemType.shipType; //改为官网类型
                                            }
                                        });
                                    },
                                );
                            }
                            this.setState({
                                isOpenchangeShipDialog: true,
                                changeShipmentList: res.data,
                                changeShipmentListLoading: false,
                            });
                        } else {
                            this.setState({
                                isOpenchangeShipDialog: false,
                                changeShipmentList: [],
                                isOpenchangeShipDialog: false,
                            });
                            this.props.openNotification(
                                T(
                                    'shopping_cart_currently_no_match_condition_sku',
                                ),
                                'danger',
                            );
                        }
                    }
                })
                .catch((err) => {
                    this.setState({
                        changeShipmentListLoading: false,
                    });
                });
        }
    };

    collectChangeShipmentSku = (inventory, value, changeSku, cartId) => {
        let currentSku = {};
        let currentChangeSkuList = this.state.changeSkuList;

        if (currentChangeSkuList.length <= 0) {
            if (value) {
                currentSku = {
                    cartId: cartId,
                    sku: changeSku,
                    inventory: inventory,
                    shipType: 2, //官网产品
                };
            }
            currentChangeSkuList.push(currentSku);
        } else {
            let isContainSku = false;
            currentChangeSkuList.forEach((item) => {
                if (item.sku === changeSku) {
                    isContainSku = true;
                }
            });
            if (isContainSku) {
                if (!value) {
                    //将官网改为现货中
                    // let result = currentChangeSkuList.filter(
                    //     (item) => item.sku != changeSku,
                    // );
                    // currentChangeSkuList = result;

                    currentChangeSkuList.forEach(
                        (currentItem, currentIndex) => {
                            if (currentItem.sku === changeSku) {
                                currentItem.shipType = 1;
                            }
                        },
                    );
                } else {
                    currentChangeSkuList.forEach(
                        (currentItem, currentIndex) => {
                            if (currentItem.sku === changeSku) {
                                currentItem.shipType = 2;
                            }
                        },
                    );
                }
            } else {
                currentSku = {
                    cartId: cartId,
                    sku: changeSku,
                    inventory: inventory,
                    shipType: 2, //官网产品
                };
                currentChangeSkuList.push(currentSku);
            }
        }

        if (value) {
            currentChangeSkuList.length > 0 &&
                currentChangeSkuList.map((itemType, indexType) => {
                    this.state.changeShipmentList.length > 0 &&
                        this.state.changeShipmentList.map((item, index) => {
                            if (
                                itemType.sku === item.product.sku &&
                                itemType.sku === changeSku
                            ) {
                                item.product.type = 2; //改为官网类型
                            }
                        });
                });
        } else {
            currentChangeSkuList.length > 0 &&
                currentChangeSkuList.map((itemType, indexType) => {
                    this.state.changeShipmentList.length > 0 &&
                        this.state.changeShipmentList.map((item, index) => {
                            if (
                                itemType.sku === item.product.sku &&
                                itemType.sku === changeSku
                            ) {
                                item.product.type = 1; //改为现货中心类型
                                item.product.inventory = inventory;
                            }
                        });
                });
        }
        setTimeout(() => {
            this.setState({
                changeSkuList: currentChangeSkuList,
            });
        }, 10);
    };

    updateShipmentSkuList = () => {
        this.setState({
            changeShipmentListLoading: false,
        });
    };

    viewChoosePriceMessage = () => {
        this.setState({
            choosePriceTypeFlg: true,
        });
    };

    getPurchaseCustomerName = () => {
        let customerName = '';
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerName = routerState.customerName;
        }
        return customerName;
    };

    getPurchaseCustomerEmail = () => {
        let customerEmail = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerEmail = routerState.customerEmail;
        }
        return customerEmail;
    };

    getPurchaseCustomerScName = () => {
        let scName = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            scName = routerState.scName;
        }
        return scName;
    };

    checkedAssayIdHandle = (item, assayIdValue) => {
        console.log('item: ', item);
        console.log('assayIdValue:', assayIdValue);
        const {cartProductList} = this.state;

        let currentChangeSkuTypeLst = [];
        if (
            localStorage.getItem('changSkuTypeList') &&
            JSON.parse(localStorage.getItem('changSkuTypeList')).length > 0
        ) {
            console.log(
                "localStorage.getItem('changSkuTypeList') ",
                JSON.parse(localStorage.getItem('changSkuTypeList')),
            );
            currentChangeSkuTypeLst = JSON.parse(
                localStorage.getItem('changSkuTypeList'),
            );
        }
        if (!assayIdValue || (assayIdValue && !assayIdValue.trim())) {
            this.props.openNotification(T('shopping_cart_empty_assayId'));
            return false;
        }
        let data = {
            sku: item.sku,
            assayId: assayIdValue && assayIdValue.trim(),
            cartId: item.id,
        };
        this.props
            .checkedAssayId(data)
            .then((res) => {
                console.log('res', res);
                console.log(
                    'checkedAssayIdHandle cartProductList',
                    cartProductList,
                );

                // 找到 cartList 中与 item.id 匹配的对象
                const matchingCartItem = cartProductList.find(
                    (cartItem) =>
                        cartItem.id === item.id && cartItem.sku === item.sku,
                );
                if (
                    matchingCartItem &&
                    res &&
                    res.data &&
                    res.data.length > 0
                ) {
                    // 更新 displayAttributeList
                    matchingCartItem.displayAttributeList = res.data;
                }

                console.log(
                    'checkedAssayIdHandle cartProductList321',
                    cartProductList,
                );
                this.setState({
                    cartProductList: cartProductList,
                });
            })
            .catch((err) => {
                console.log('checkedAssayIdHandle err', err);
                if (err && err.status === 'Invalid_AssayId') {
                    this.props.openNotification(
                        T('shopping_cart_invalid_assayId'),
                    );
                }
            });
    };

    checkedAssayIdChangeSkuType = (currentChangeSkuTypeLst) => {
        if (currentChangeSkuTypeLst && currentChangeSkuTypeLst.length > 0) {
            this.setState({
                cartUpdate: true,
            });
        }
        let currentCartProductList = JSON.parse(
            JSON.stringify(this.state.cartProductList),
        );

        currentChangeSkuTypeLst.length > 0 &&
            currentChangeSkuTypeLst.map((itemType, indexType) => {
                currentCartProductList.map((item, index) => {
                    if (itemType.sku === item.product.sku) {
                        item.product.type = itemType.shipType; //改为官网类型
                        item.product.availableInventory = itemType.inventory;
                    }
                });
            });

        this.setState({
            cartProductList: currentCartProductList,
        });
    };

    render() {
        const {
            checkAll,
            deleteStatus,
            defaultCheck,
            checkNum,
            inputdiscountCodeList,
            discountCode,
            pageLoading,
            isOnlinePrice,
            promoWarningFlg,
            cartProductList,
            isQuoteInfor,
            displayTMProduct,
            isDemoSite,
            pageLoad,
            reselectAllProductCheck,
            sQuote,
            discountFocus,
            sQuoteClearFlg,
            choosePriceTypeFlg,
            sQuoteConfirmFlg,
            sQuoteNum,
            promoErrorMsg,
            isOpenchangeShipDialog,
            changeShipmentList,
            changeShipmentListLoading,
            updateChoosePrice,
            existOnlinePriceDialog,
            quickAddSkuValue,
            quickAddSkuQuantity,
            changeDeliveryChannelToE1Dialog,
        } = this.state;
        const {
            cartPrice,
            localData,
            cartList,
            quoteInfor,
            quoteCustomerInfor,
            recommendedProductList,
            listLoaded,
            recommendedProductLoadingMore,
            tmProductList,
            cartActivity,
            sPrice,
        } = this.props;
        console.log(
            'render===================this.state.cartProductList=============================',
            JSON.parse(JSON.stringify(cartProductList)),
        );

        console.log(
            this.getBatchAddShipTo(),
            '=============================this.getBatchAddShipTo()',
        );

        this.disableOverFlow(pageLoading);
        const hasWebOnlyPrice = this.checkWebOnlyPrice(cartList);

        const chooseProductList = displayTMProduct
            ? tmProductList
            : recommendedProductList;
        const productAbyss = displayTMProduct
            ? true
            : chooseProductList.pageNum >= chooseProductList.pageTotal;
        let lang = loadLanguage();
        let currentSupplyCenterId = this.getBatchAddShipTo()
            ? -1
            : localData.scId
            ? localData.scId
            : localData.defaultScId
            ? localData.defaultScId
            : NO_SUPPLY_CENTER_ID;

        console.log(
            '!this.getBatchAddShipTo()======',
            !this.getBatchAddShipTo(),
        );
        console.log(
            'typeof localData.scId && localData.defaultScId======',
            typeof localData.scId && localData.defaultScId,
            localData,
        );
        console.log(
            'shoppingCart======================checkNum====================================',
            checkNum,
        );

        return (
            <div className="shopping-cart lto-shopping-cart">
                <div
                    className={util.getClassName({
                        'container-max-width': true,
                        'is-fixed': true,
                        background: true,
                        'background-activity':
                            true && cartActivity && cartActivity.id,
                    })}></div>
                <div
                    id={
                        util.getPurchaseOrderMode() ===
                        PURCHASE_ORDER_MODE.OFFLINE
                            ? 'offlineHeaderBackgroundCover'
                            : ''
                    }
                    className={util.getClassName({
                        'container-max-width': true,
                        'is-fixed': true,
                        'background-cover': true,
                        'background-cover-activity':
                            true && cartActivity && cartActivity.id,
                    })}></div>
                {pageLoading ? (
                    <div className="checkout-loading-mask">
                        <LoadingIcon className="circle-animation" />
                    </div>
                ) : null}

                <Header
                    isShoppingCart={true}
                    cartActivity={cartActivity}
                    increment={0}
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    currentSupplyCenterId={currentSupplyCenterId}
                    ltoPageTitle={T('shoppingCart')}
                    testid="shopping-cart-go-back-btn"
                    backEvent={this.backButtonAction}>
                    <Grid
                        className={
                            !this.getBatchAddShipTo()
                                ? 'supply-center-container no-margin'
                                : 'supply-center-container batch-supply-center no-margin'
                        }
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        {util.getPurchaseOrderMode() ===
                            PURCHASE_ORDER_MODE.ONLINE && (
                            <Grid
                                className="customer-email-content"
                                item
                                xs={11}>
                                <img
                                    src={
                                        new URL(
                                            'Images/customer_icon.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />
                                <label className="text-ellipsis">
                                    {util.getPurchaseCustomerName()}
                                </label>
                                <label className="text-ellipsis">
                                    {util.getPurchaseCustomerEmail()}
                                </label>
                            </Grid>
                        )}

                        <Grid className="shipto-and-sc" item xs={12}>
                            <Grid
                                className="left-content"
                                item
                                xs={4}
                                testid="shopping_cart_header_ship_to_number">
                                <img
                                    src={
                                        new URL(
                                            'Images/ST.svg',
                                            import.meta.url,
                                        ).href
                                    }
                                    alt=""
                                />
                                {localData.shipToNum}
                            </Grid>
                            <Grid
                                className="supply-center-title text-ellipsis"
                                item
                                xs={8}>
                                {!this.getBatchAddShipTo() ? (
                                    <PlaceOutlined />
                                ) : null}
                                <span className="text-ellipsis">
                                    {!this.getBatchAddShipTo()
                                        ? this.getPurchaseCustomerScName()
                                            ? this.getPurchaseCustomerScName()
                                            : localData.scName
                                        : null}
                                </span>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid
                        className="page-title-container no-margin lto-page-title-container"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid
                            className="page-title lto-page-title"
                            item
                            xs={10}>
                            <span>
                                {localData.roleType === 1 ||
                                localData.roleType === 3 ? (
                                    !this.getBatchAddShipTo() &&
                                    (typeof localData.scId ||
                                        localData.defaultScId) ? (
                                        <Grid
                                            item
                                            xs={4}
                                            className="change-ship-icon">
                                            <IconButton
                                                id="changeShipBtn"
                                                testid="change-ship-btn"
                                                onClick={this.changeShipEvent.bind(
                                                    this,
                                                )}
                                                className="shopping-cart-icon"
                                                color="inherit">
                                                <img
                                                    alt=""
                                                    src={
                                                        new URL(
                                                            'Images/new_cart.svg',
                                                            import.meta.url,
                                                        ).href
                                                    }
                                                />
                                            </IconButton>
                                        </Grid>
                                    ) : null
                                ) : null}
                            </span>
                        </Grid>
                        <Grid className="delete-button" item xs={2}>
                            <a
                                onClick={this.switchStatus}
                                testid="shopping-cart-delete-btn">
                                <span
                                    testid={
                                        deleteStatus
                                            ? 'shopping-cart-delete-btn-text'
                                            : 'shopping-cart-cancel-btn-text'
                                    }>
                                    {deleteStatus
                                        ? T('shopping_cart_delete_button')
                                        : T('shopping_cart_cancel')}
                                </span>
                            </a>
                        </Grid>
                    </Grid>
                </Header>

                {hasWebOnlyPrice ? (
                    <Grid
                        className="price-choose-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid item xs={12}>
                            <Card className="order-card">
                                <Grid
                                    className="price-choose"
                                    container
                                    spacing={0}
                                    justify={'space-evenly'}>
                                    <Grid className="choose-label" item xs={3}>
                                        <span>
                                            {T(
                                                'shopping_cart_choose_preferential_type',
                                            )}
                                        </span>
                                        <InfoOutlined
                                            onClick={this.viewChoosePriceMessage.bind()}
                                        />
                                    </Grid>
                                    <Grid
                                        className="price-switch-radio"
                                        item
                                        xs={9}>
                                        <Radio
                                            checked={!isOnlinePrice}
                                            testid="shopping-cart-discount-price-radio"
                                            onChange={this.handleSwitch}
                                            className={
                                                !isOnlinePrice
                                                    ? 'discount-price chosen'
                                                    : 'discount-price'
                                            }
                                        />
                                        <span
                                            className={
                                                !isOnlinePrice
                                                    ? 'price-label chosen'
                                                    : 'price-label'
                                            }>
                                            {T('shopping_cart_discount_price')}
                                        </span>
                                        <Radio
                                            checked={isOnlinePrice}
                                            testid="shopping-cart-online-price-radio"
                                            onChange={this.handleSwitch}
                                            className={
                                                isOnlinePrice
                                                    ? 'online-price chosen'
                                                    : 'online-price'
                                            }
                                        />
                                        <span
                                            className={
                                                isOnlinePrice
                                                    ? 'price-label chosen'
                                                    : 'price-label'
                                            }>
                                            {T(
                                                'shopping_cart_global_group_best_price',
                                            )}
                                        </span>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                ) : null}

                <Grid
                    className={
                        inputdiscountCodeList.length > 0
                            ? 'shopping-cart-list-container no-margin adjust-margin'
                            : 'shopping-cart-list-container no-margin'
                    }
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    {cartProductList.length <= 0 && !sQuote ? (
                        <Grid className="empty-shopping-cart">
                            <img
                                alt=""
                                src={
                                    new URL(
                                        'Images/shoppingCart-empty.png',
                                        import.meta.url,
                                    ).href
                                }
                            />
                            <Grid
                                className="empty-shopping-cart-text"
                                testid="shopping_cart_empty_text">
                                {T('shopping_cart_empty')}
                            </Grid>
                        </Grid>
                    ) : null}
                    {cartProductList &&
                        cartProductList.map((item, i) => {
                            return (
                                <Grid
                                    className="shopping-cart-list"
                                    key={item.id}
                                    item
                                    xs={12}>
                                    <ProductCard
                                        productInfo={item.product}
                                        customerData={this.props.localData}
                                        item={item}
                                        itemPosition={'cart'}
                                        history={this.props.history}
                                        isShoppingCart={true}
                                        handleCheck={this.handleSingleCheck}
                                        defaultCheck={defaultCheck}
                                        reselectAllProductCheck={
                                            reselectAllProductCheck
                                        }
                                        changeNum={this.changeNum}
                                        cartInfo={item}
                                        codeList={inputdiscountCodeList}
                                        updatedInfo={this.updatePrice(
                                            item,
                                            cartPrice,
                                        )}
                                        skuPricesObj={
                                            cartPrice.data &&
                                            cartPrice.data.skuPrices.find(
                                                (t) => t.cartId === item.id,
                                            )
                                        }
                                        updateChoosePrice={updateChoosePrice}
                                        cartPrice={cartPrice}
                                        discountCode={discountCode}
                                        sPrice={sPrice}
                                        displayOnlinePrice={isOnlinePrice}
                                        getQuote={this.getQuote}
                                        quoteInfor={quoteCustomerInfor}
                                        isQuoteInfor={isQuoteInfor}
                                        closeQuoteDetails={
                                            this.closeQuoteDetails
                                        }
                                        copyContent={this.copyContent}
                                        checkedAssayIdHandle={
                                            this.checkedAssayIdHandle
                                        }
                                        otherDivision={false}
                                    />
                                </Grid>
                            );
                        })}
                </Grid>

                {sPrice ? (
                    <Grid className="s-quote-products">
                        <Grid
                            className="s-quote-products-content"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            <Grid
                                className="content-title"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid className="dicount-code" item xs={10}>
                                    <span>
                                        {T('order_discount_code') +
                                            '-' +
                                            sQuote}
                                    </span>
                                </Grid>

                                <Grid className="delete-button" item xs={2}>
                                    <Anchor
                                        testid="shopping-cart-clear-btn"
                                        onClickOfSingleTap={this.removeSItems}>
                                        <span>{T('shopping_cart_clear')}</span>
                                    </Anchor>
                                </Grid>

                                {sPrice.orderType !== 'SCM' ? (
                                    <Grid
                                        className="tf-warning-message"
                                        item
                                        xs={12}>
                                        <span testid="tm-website-delivery-indicator">
                                            {T('order_global_delivery')}
                                        </span>
                                    </Grid>
                                ) : null}
                            </Grid>

                            {sPrice.orderLineDetails &&
                                sPrice.orderLineDetails.map((item, i) => {
                                    return (
                                        <Grid
                                            className="content-details"
                                            container
                                            spacing={0}
                                            justify={'space-evenly'}>
                                            <SQuoteItem
                                                item={item}
                                                orderType={sPrice.orderType}>
                                                <div className="price-box">
                                                    <Grid
                                                        className="price-container"
                                                        item
                                                        xs={8}>
                                                        <Grid
                                                            className="price-grid"
                                                            container
                                                            spacing={0}>
                                                            <Grid
                                                                className="discount-price"
                                                                item
                                                                xs={12}>
                                                                <span className="price number-font price-font line-through">
                                                                    {util.toMoney(
                                                                        item.listPrice,
                                                                    )}
                                                                </span>
                                                                {T(
                                                                    'order_list_price',
                                                                )}
                                                            </Grid>

                                                            <Grid
                                                                className="discount-code"
                                                                item
                                                                xs={12}>
                                                                <span className="price number-font price-font">
                                                                    <i className="rmb"></i>{' '}
                                                                    <b>
                                                                        {util.toMoney(
                                                                            item.unitPrice,
                                                                        )}
                                                                    </b>{' '}
                                                                    {T(
                                                                        'order_discount_price',
                                                                    )}
                                                                </span>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid
                                                        className="product-number"
                                                        item
                                                        xs={3}>
                                                        <span>
                                                            x{item.desiredQty}
                                                        </span>
                                                    </Grid>
                                                </div>
                                            </SQuoteItem>
                                        </Grid>
                                    );
                                })}
                        </Grid>
                    </Grid>
                ) : null}

                <Grid className="quick-sku-container" xs={12}>
                    <Grid className="quick-add-product-title">
                        <Grid
                            className={util.getClassName({
                                'quick-add-product-title-area':
                                    true && lang !== 'EN',
                                'en-quick-add-product-title-area':
                                    true && lang === 'EN',
                            })}>
                            {/* <img
                                alt=""
                                src={new URL('Images/icon-hot.png', import.meta.url).href}
                            /> */}
                            <AddCircle className="quick-add-sku-icon"></AddCircle>
                            <span className="quick-add-product-line">
                                {T('shopping_cart_quickly_add_product')}
                            </span>
                        </Grid>
                    </Grid>
                    <div className="add-sku-container">
                        <div className="sku-rows">
                            <label className="required-label">*</label>
                            <LabelInput
                                defaultValue={quickAddSkuValue}
                                title={'quickAddSkuValue'}
                                placeholder={T('backup_please_input_sku')}
                                inputValid={this.handleQuickAddSkuChange}
                                testid="shopping-cart-quick-add-sku-input"
                                type="text"
                            />
                            <Counter
                                defalutValue={quickAddSkuQuantity}
                                inputValid={this.quickAddSkuQuantityChange}
                                options={{min: 1}}
                                testid="shopping-cart-quick-add-sku-quantity"
                            />
                            <div className="add-sku-label">
                                <Anchor
                                    className="add-quick-sku-a"
                                    testid="add-quick-sku-btn"
                                    onClickOfSingleTap={() =>
                                        this.quickAddSkuHandle()
                                    }>
                                    <span className="add-quick-sku-btn">
                                        {T('host_abnormal_add')}
                                    </span>
                                </Anchor>
                            </div>
                        </div>
                    </div>
                </Grid>

                <Grid
                    className="page-bottom-container container-max-width is-fixed no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    {/*		      		{ !isOnlinePrice ? <Grid className='discount-code-container' item xs={12}>
				                		<Grid className='discount-code-grid' container spacing={0}>
				                			<Grid item xs={9}>
					                    		<LabelInput defaultValue={discountCode} title={'discountCode'} placeholder={T('promotional_code')} inputValid={this.handleDiscountChange} type='text'/>
					                    	</Grid>
					                    	<Grid item xs={2}>
							      				<BasicButton className='apply-button' disabled={inputdiscountCodeList.length > 1 ? true : false} type='info' onClickOfSingleTap={this.applyCode}>
							      				 	{T('apply')}
							      				</BasicButton>
					                    	</Grid>
								            { inputdiscountCodeList && inputdiscountCodeList.map((item) => {
							            			return  <div className='selected-code' key={item}>
											      				{item}<span onClick={this.clearCode.bind(this, item)}>{T('shopping_cart_clear')}</span>
									                    	</div>
							                    })
					                    	}
					                    </Grid>
					                </Grid> : null
					}*/}

                    <Grid className="discount-code-container" item xs={12}>
                        <Grid
                            className="discount-code-grid"
                            container
                            spacing={0}>
                            {
                                <Grid className="promo-input" item xs={9}>
                                    <LabelInput
                                        defaultValue={discountCode}
                                        title={'discountCode'}
                                        placeholder={
                                            inputdiscountCodeList &&
                                            inputdiscountCodeList.length > 1
                                                ? ''
                                                : T('promotional_code')
                                        }
                                        testid="cart-input-quote"
                                        inputValid={this.handleDiscountChange}
                                        type="text"
                                    />
                                </Grid>
                            }
                            <Grid item xs={3}>
                                <BasicButton
                                    className="apply-button"
                                    disabled={
                                        inputdiscountCodeList.length >= 2
                                            ? true
                                            : false
                                    }
                                    type="info"
                                    testid="apply-code-btn"
                                    onClickOfSingleTap={this.applyCode}>
                                    {T('apply')}
                                </BasicButton>
                            </Grid>
                            {/*				            { inputdiscountCodeList && inputdiscountCodeList.map((item) => {
								            			return  <div className='selected-code' key={item}>
												      				{item}<span onClick={this.clearCode.bind(this, item)}>{T('shopping_cart_clear')}</span>
										                    	</div>
								                    })
						                    	}*/}
                            {inputdiscountCodeList &&
                            inputdiscountCodeList[0] ? (
                                <div
                                    testid={
                                        inputdiscountCodeList[0]
                                            .trim()
                                            .substring(0, 1)
                                            .toUpperCase() === 'S'
                                            ? 's-quote-code'
                                            : 'discount-code'
                                    }
                                    className={
                                        inputdiscountCodeList[0]
                                            .trim()
                                            .substring(0, 1)
                                            .toUpperCase() === 'S'
                                            ? 'selected-code sQuote'
                                            : 'selected-code'
                                    }>
                                    {inputdiscountCodeList[0]}
                                    <span
                                        testid="shopping-cart-clear-coupon-btn"
                                        onClick={this.clearCode.bind(
                                            this,
                                            inputdiscountCodeList[0],
                                        )}>
                                        {T('shopping_cart_clear')}
                                    </span>
                                </div>
                            ) : (
                                <div
                                    className="empty-code"
                                    onClick={this.promoFocus}>
                                    <span>{T('discount_code')}</span>
                                </div>
                            )}

                            {inputdiscountCodeList &&
                            inputdiscountCodeList[1] ? (
                                <div
                                    testid={
                                        inputdiscountCodeList[1]
                                            .trim()
                                            .substring(0, 1)
                                            .toUpperCase() === 'S'
                                            ? 's-quote-code'
                                            : 'discount-code'
                                    }
                                    className={
                                        inputdiscountCodeList[1]
                                            .trim()
                                            .substring(0, 1)
                                            .toUpperCase() === 'S'
                                            ? 'selected-code code-two sQuote'
                                            : 'selected-code code-two'
                                    }>
                                    {inputdiscountCodeList[1]}
                                    <span
                                        testid="shopping-cart-clear-coupon-btn"
                                        onClick={this.clearCode.bind(
                                            this,
                                            inputdiscountCodeList[1],
                                        )}>
                                        {T('shopping_cart_clear')}
                                    </span>
                                </div>
                            ) : (
                                <div
                                    className="empty-code code-two"
                                    onClick={this.promoFocus}>
                                    <span>{T('discount_code')}</span>
                                </div>
                            )}
                        </Grid>
                    </Grid>

                    <Grid className="all-selected" item xs={3}>
                        <Checkbox
                            checked={checkAll}
                            onChange={this.handleCheck.bind(this)}
                            testid="shopping-cart-select-all-checkbox"
                        />
                        <span className="all-selected-title">
                            {T('shopping_cart_select_all')}
                        </span>
                    </Grid>

                    {deleteStatus ? (
                        <React.Fragment>
                            <Grid className="total-price" item xs={5}>
                                {T('order_total_colon')}
                                <span>
                                    <i className="rmb"></i>{' '}
                                    <span
                                        className="price price-font"
                                        testid="shopping_cart_total_price">
                                        {this.getTotalPrice(
                                            localData.skuPrices,
                                        )}
                                    </span>
                                </span>
                            </Grid>
                            <Grid className="calculate-button" item xs={4}>
                                <BasicButton
                                    type="primary"
                                    testid="shopping-cart-settle-btn"
                                    disabled={
                                        checkNum + sQuoteNum ? false : true
                                    }
                                    onClickOfSingleTap={
                                        this.goToOrderConfirmation
                                    }>
                                    <span>
                                        {T('shopping_cart_settle', [
                                            checkNum + sQuoteNum,
                                        ])}
                                    </span>
                                </BasicButton>
                            </Grid>
                        </React.Fragment>
                    ) : (
                        <Grid className="delete-button" item xs={9}>
                            <BasicButton
                                type="info"
                                testid="shopping-cart-delete-btn"
                                disabled={false}
                                onClickOfSingleTap={this.deleteItem}>
                                <span>
                                    {T('shopping_cart_delete', [
                                        this.getDeleteNum(),
                                    ])}
                                </span>
                            </BasicButton>
                        </Grid>
                    )}
                </Grid>

                <Dialog
                    opened={promoWarningFlg}
                    dialogDidClose={() =>
                        this.dialogDidClose('promoWarningFlg')
                    }
                    options={{bgClickClose: true}}>
                    <div className="promo-warning-dialog">
                        <span testid="shopping_cart_coupon_error_msg">
                            {promoErrorMsg}
                        </span>
                        <BasicButton
                            className="confirm-btn"
                            type="primary"
                            testid="shopping_cart_coupon_error_close_btn"
                            onClickOfSingleTap={() =>
                                this.dialogDidClose('promoWarningFlg')
                            }>
                            {T('shopping_cart_close')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={sQuoteClearFlg}
                    dialogDidClose={() => this.dialogDidClose('sQuoteClearFlg')}
                    options={{bgClickClose: true}}>
                    <div className="promo-warning-dialog">
                        <span>{T('shopping_cart_s_quote_remove')}</span>
                        <BasicButton
                            className="confirm-btn"
                            type="primary"
                            onClickOfSingleTap={() =>
                                this.sQuoteDialogClose('sQuoteClearFlg')
                            }>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={choosePriceTypeFlg}
                    dialogDidClose={() =>
                        this.dialogDidClose('choosePriceTypeFlg')
                    }
                    options={{bgClickClose: true}}>
                    <div className="choose-price-dialog">
                        {/* <span>
                            {isOnlinePrice
                                ? T('shopping_cart_group_best_price_message')
                                : T('shopping_cart_discount_price_message')}
                        </span> */}
                        <div>
                            <label className="choose-price-label">
                                {T('shopping_cart_discount_price')}：
                            </label>
                            <div>
                                {T('shopping_cart_discount_price_message')}
                            </div>
                        </div>
                        <div>
                            <label className="choose-price-label">
                                {T('shopping_cart_global_group_best_price')}：
                            </label>
                            <div>
                                {T('shopping_cart_group_best_price_message')}
                            </div>
                        </div>
                        <BasicButton
                            className="confirm-btn"
                            type="primary"
                            onClickOfSingleTap={() =>
                                this.dialogDidClose('choosePriceTypeFlg')
                            }>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={existOnlinePriceDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('existOnlinePriceDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="confirm-apply-quote-dialog">
                        <div className="confirm-label">
                            {T('order_please_confirm')}
                        </div>
                        <span>{T('order_r_quote_please_confirm')}</span>
                        <span>{T('order_r_quote_info')}</span>
                        <div className="apply-quote-btn-container">
                            <BasicButton
                                className="confirm-btn cancel-apply-quote-btn"
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'existOnlinePriceDialog',
                                    )
                                }>
                                {T('btn_action_cancel')}
                            </BasicButton>
                            <BasicButton
                                className="confirm-btn"
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.wopApplyRQuote()
                                }>
                                {T('yes')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={changeDeliveryChannelToE1Dialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('changeDeliveryChannelToE1Dialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="confirm-apply-quote-dialog">
                        <div className="confirm-label">
                            {T('order_please_confirm')}
                        </div>
                        <span>{T('shopping_cart_apply_m_quote_message')}</span>
                        <div className="apply-quote-btn-container">
                            <BasicButton
                                className="confirm-btn cancel-apply-quote-btn"
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'changeDeliveryChannelToE1Dialog',
                                    )
                                }>
                                {T('btn_action_cancel')}
                            </BasicButton>
                            <BasicButton
                                className="confirm-btn"
                                type="primary"
                                onClickOfSingleTap={() => this.applyMQuote()}>
                                {T('yes')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={sQuoteConfirmFlg}
                    dialogDidClose={() =>
                        this.dialogDidClose('sQuoteConfirmFlg')
                    }
                    options={{bgClickClose: true}}>
                    <div className="s-quote-confirm-dialog">
                        <div className="dialog-title">
                            <p>
                                {T('shopping_cart_confirm_msg_one', [sQuote])}
                            </p>
                            <p>{T('shopping_cart_confirm_msg_two')}</p>
                        </div>
                        <div className="dialog-content">
                            {sPrice &&
                                sPrice.orderLineDetails &&
                                sPrice.orderLineDetails.map((item, i) => {
                                    return (
                                        <Grid
                                            className="order-line-info"
                                            key={i}
                                            container
                                            spacing={0}>
                                            <Grid
                                                className="sku-no"
                                                item
                                                xs={9}>
                                                <span>
                                                    {T('sku')}: {item.sku}
                                                </span>
                                            </Grid>

                                            <Grid
                                                className="sku-amount"
                                                item
                                                xs={3}>
                                                <span>x{item.desiredQty}</span>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                        </div>
                        <div
                            className="dialog-close"
                            onClick={() =>
                                this.dialogDidClose('sQuoteConfirmFlg')
                            }>
                            {/*<CloseOutlined />*/}
                            <BasicButton className="confirm-btn" type="primary">
                                {T('shippment_confirm')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                {changeShipmentListLoading ? (
                    <div className="checkout-change-shipment-loading-mask">
                        <LoadingIcon className="circle-animation" />
                    </div>
                ) : (
                    <Dialog
                        opened={isOpenchangeShipDialog}
                        dialogDidClose={() =>
                            this.dialogDidClose('isOpenchangeShipDialog')
                        }
                        options={{bgClickClose: true}}>
                        <div className="change-shipment-dialog">
                            <div className="dialog-title">
                                <p>
                                    {T('shopping_cart_change_shipment', [
                                        sQuote,
                                    ])}
                                </p>
                            </div>
                            <div className="dialog-content">
                                <Grid
                                    className={
                                        inputdiscountCodeList.length > 0
                                            ? 'shopping-cart-list-container no-margin adjust-margin'
                                            : 'shopping-cart-list-container no-margin'
                                    }
                                    container
                                    spacing={0}
                                    justify={'space-evenly'}>
                                    {changeShipmentList &&
                                        changeShipmentList.map((item, i) => {
                                            return (
                                                <Grid
                                                    className="change-shipment-cart-list"
                                                    key={item.id}
                                                    item
                                                    xs={12}>
                                                    <ChangeShipmentCard
                                                        productInfo={
                                                            item.product
                                                        }
                                                        isShoppingCart={true}
                                                        handleCheck={
                                                            this
                                                                .handleSingleCheck
                                                        }
                                                        defaultCheck={
                                                            defaultCheck
                                                        }
                                                        reselectAllProductCheck={
                                                            reselectAllProductCheck
                                                        }
                                                        changeNum={
                                                            this.changeNum
                                                        }
                                                        collectChangeShipmentSku={
                                                            this
                                                                .collectChangeShipmentSku
                                                        }
                                                        cartInfo={item}
                                                        codeList={
                                                            inputdiscountCodeList
                                                        }
                                                        updatedInfo={this.updatePrice(
                                                            item,
                                                            cartPrice,
                                                        )}
                                                        skuPricesObj={
                                                            cartPrice.data &&
                                                            cartPrice.data.skuPrices.find(
                                                                (t) =>
                                                                    t.cartId ===
                                                                    item.id,
                                                            )
                                                        }
                                                        displayOnlinePrice={
                                                            isOnlinePrice
                                                        }
                                                        getQuote={this.getQuote}
                                                        quoteInfor={
                                                            quoteCustomerInfor
                                                        }
                                                        isQuoteInfor={
                                                            isQuoteInfor
                                                        }
                                                        closeQuoteDetails={
                                                            this
                                                                .closeQuoteDetails
                                                        }
                                                        copyContent={
                                                            this.copyContent
                                                        }
                                                    />
                                                </Grid>
                                            );
                                        })}
                                </Grid>
                            </div>
                            <BasicButton
                                className="close-change-shipment-btn"
                                testid="shopping-cart-close-change-shipment-btn"
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'isOpenchangeShipDialog',
                                    )
                                }>
                                {T('shopping_cart_close')}
                            </BasicButton>
                            {/* <div className="dialog-close">
						</div> */}
                        </div>
                    </Dialog>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {order, localData} = state;
    return {
        cartList: order.cartList.data,
        localData: localData,
        supplyCenter: order.supplyCenter,
        cartPrice: order.cartPrice,
        switchChoosePrice: order.switchChoosePrice,
        quoteInfor: order.quoteInfor.data,
        quoteCustomerInfor: order.quoteCustomerInfor.data,
        listLoaded: order.recommendedProductListLoaded,
        recommendedProductLoadingMore: order.recommendedProductLoadingMore,
        tmProductList: order.tmProductList,
        recommendedProductList: order.recommendedProductList,
        cartActivity: order.cartActivity.data,
        sPrice: order.sPrice,
    };
};

const mapDispatchToProps = {
    queryCart,
    queryChangeShip,
    deleteCart,
    calculatePrice,
    setCartDetails,
    sumbitQuantity,
    openNotification,
    queryEoneInventory,
    getQuote,
    getCustomerQuote,
    addCart,
    getCartCount,
    operationLog,
    calculateSquotePrice,
    setCartOrderNumber,
    updateSwitchChoosePrice,
    batchAddCart,
    updateFromShoppingCart,
    checkedAssayId,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart);
